import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  StringCompanionObject_instance1kavzb69ik84p as StringCompanionObject_instance,
  Unit_instanceat14thlj150z as Unit_instance,
  emptyList1g2z5xcrvp2zy as emptyList,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  asList2ho2pewtsfvv as asList,
  toString1pkumu07cwy4m as toString,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  captureStack1fzi4aczwc4hg as captureStack,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KClass1cc9rfeybg8hs as KClass,
  isInterface3d6p8outrmvmk as isInterface,
  Triple1vhi3d0dgpnjb as Triple,
  getKClass1s3j9wy1cofik as getKClass,
  Paire9pteg33gng7 as Pair,
  Entry2xmjmyutzoq3p as Entry,
  KtMap140uvy3s5zad8 as KtMap,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  HashMap1a0ld5kgwhmhv as HashMap,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashSet2dzve9y63nf0v as HashSet,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
  copyToArray2j022khrow2yi as copyToArray,
  _Result___get_value__impl__bjfvqgbxrwpgk5sesh as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2jp2gwqhnirp8 as _Result___get_isFailure__impl__jpiriv,
  Result3t1vadv16kmzk as Result,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Iterable1y3qizuf89iou as Iterable,
  isBlank1dvkhjjvox3p0 as isBlank,
  toList383f556t1dixk as toList,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
  withIndex3s8q7w1g0hyfn as withIndex,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  lazy2hsh8ze7j6ikd as lazy_0,
  contentEqualsaf55p28mnw74 as contentEquals,
  until1jbpn0z3f8lbg as until,
  joinToString1cxrrlmo0chqs as joinToString,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Long2qws0ah9gnpki as Long,
  Char19o2r8palgjof as Char,
  createThis2j2avj17cvnv2 as createThis,
  Duration__toIsoString_impl_9h6wsm2kf5is6ue36 as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  hashCodeq5arwsb9dgti as hashCode,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  isArray1hxjqtqy632bc as isArray,
  arrayIterator3lgwvgteckzhv as arrayIterator,
  step18s9qzr5xwxat as step,
  getValue48kllevslyh6 as getValue,
  longArray288a0fctlmjmj as longArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_lastIndex1y2f6o9u8hnf7 as get_lastIndex,
  countTrailingZeroBits1k55x07cygoff as countTrailingZeroBits,
  indexOf3ic8eacwbbrog as indexOf,
  contentToString3ujacv8hqfipd as contentToString,
  Enum3alwj03lh1n41 as Enum,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getOrNull1d60i0672n7ns as getOrNull,
  toString30pk9tzaqopn as toString_0,
  KTypeParameter1s8efufd4mbj5 as KTypeParameter,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  booleanArray2jdug9b51huk7 as booleanArray,
  emptyMapr06gerzljqtm as emptyMap,
  Companion_getInstance107vs7n7usf4y as Companion_getInstance_0,
  isCharArray21auq5hbrg68m as isCharArray,
  charArray2ujmm1qusno00 as charArray,
  DoubleCompanionObject_instance173s5lyb0q261 as DoubleCompanionObject_instance,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  FloatCompanionObject_instance2nv8eonbbzzfx as FloatCompanionObject_instance,
  isFloatArrayjjscnqphw92j as isFloatArray,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance_1,
  isLongArray2fdt3z7yu3ef as isLongArray,
  Companion_getInstance2r8lbbjwejmb0 as Companion_getInstance_2,
  _ULongArray___get_size__impl__ju6dtr5v7zdjz7p45k as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l32q6yolvdd31u5 as _ULongArray___init__impl__twm1l3,
  _ULong___init__impl__c78o9k1neui78jb9mlg as _ULong___init__impl__c78o9k,
  ULongArray__get_impl_pr71q92g1kdq5mz2hdv as ULongArray__get_impl_pr71q9,
  _ULong___get_data__impl__fggpzb77rs34yu2akv as _ULong___get_data__impl__fggpzb,
  IntCompanionObject_instance3gkmaao3ynimd as IntCompanionObject_instance,
  isIntArrayeijsubfngq38 as isIntArray,
  Companion_getInstance316n37o3eume as Companion_getInstance_3,
  _UIntArray___get_size__impl__r6l8ci3qgksw2fv2zbg as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc61y58bc9dz2k51 as _UIntArray___init__impl__ghjpc6,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
  UIntArray__get_impl_gp5kzae60hwt0gkwo9 as UIntArray__get_impl_gp5kza,
  _UInt___get_data__impl__f0vqqw1wfqgh301wggv as _UInt___get_data__impl__f0vqqw,
  ShortCompanionObject_instance12gf1264cm017 as ShortCompanionObject_instance,
  isShortArraywz30zxwtqi8h as isShortArray,
  Companion_getInstance3956vha054dts as Companion_getInstance_4,
  _UShortArray___get_size__impl__jqto1b36yuj0vpbb4fa as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26ef3n50inn0xrhd8 as _UShortArray___init__impl__9b26ef,
  _UShort___init__impl__jigrne18f2wrm3i4dpy as _UShort___init__impl__jigrne,
  UShortArray__get_impl_fnbhmx1y5d8996erjf3 as UShortArray__get_impl_fnbhmx,
  _UShort___get_data__impl__g02453buibbzrpmeid as _UShort___get_data__impl__g0245,
  ByteCompanionObject_instance1hjbskmeqhwpn as ByteCompanionObject_instance,
  isByteArray4nnzfn1x4o3w as isByteArray,
  Companion_getInstance16xypb6k4bny3 as Companion_getInstance_5,
  _UByteArray___get_size__impl__h6pkdv15deqqx7xzfdr as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n1hit86mr6wg8d as _UByteArray___init__impl__ip4y9n,
  _UByte___init__impl__g9hnc43i8t7wecfr79w as _UByte___init__impl__g9hnc4,
  UByteArray__get_impl_t5f3hv1encpe8trq9zx as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  BooleanCompanionObject_instance3nn0izprmvlr6 as BooleanCompanionObject_instance,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  _ULongArray___get_storage__impl__28e64jz3ai25vchwgx as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l3owlgsbcrjm9i as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh1fkdkvkvugioz as ULongArray__set_impl_z19mvh,
  copyOf3rutauicler23 as copyOf_3,
  _UIntArray___get_storage__impl__92a0v0roqxtd6s3fgh as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc6c5ddvnp6r87k as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu21dnkvvxogtuwl as UIntArray__set_impl_7f2zu2,
  copyOf39s58md6y6rn6 as copyOf_4,
  _UShortArray___get_storage__impl__t2jpv53svtj69qk6zql as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef2aibpqatnrmu4 as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp2i4vsez7wuaa8 as UShortArray__set_impl_6d8whp,
  copyOfwy6h3t5vzqpl as copyOf_5,
  _UByteArray___get_storage__impl__d4kctt1v2w0kp012p35 as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n3sp5zyufbcv0v as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicn11526muxjy7z7 as UByteArray__set_impl_jvcicn,
  copyOf37mht4mx7mjgh as copyOf_6,
  Unitkvevlwgzwiuc as Unit,
  trimIndent1qytc1wvt8suh as trimIndent,
  equals2v6cggk171b6e as equals_0,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  toString14fd7g605f91p as toString_1,
  titlecase36e9fbud5gg4t as titlecase,
  isLowerCase16nv9n55l9laa as isLowerCase,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  ULong3f9k7s38t3rfp as ULong,
  UInt1hthisrv6cndi as UInt,
  UShort26xnqty60t7le as UShort,
  UBytep4j7r1t64gz1 as UByte,
  mapOf1xd03cq9cnmy8 as mapOf,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  get_lastIndex1yw0x4k50k51w as get_lastIndex_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  asSequence2lno4vpru4ldl as asSequence,
  get_js1ale1wr4fbvs0 as get_js,
  findAssociatedObject1kb88g16k1goa as findAssociatedObject,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  get_indicesc04v40g017hw as get_indices,
  get_indices377latqcai313 as get_indices_0,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class SerializationStrategy {}
class DeserializationStrategy {}
class KSerializer {}
class AbstractPolymorphicSerializer {
  static ov() {
    return createThis(this);
  }
  rv(encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.yu();
    var composite = encoder.xy(descriptor);
    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
    composite.n10(this.yu(), 0, actualSerializer.yu().ax());
    var tmp = this.yu();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.p10(tmp, 1, tmp$ret$0, value);
    composite.yy(descriptor);
  }
  zu(encoder, value) {
    return this.rv(encoder, !(value == null) ? value : THROW_CCE());
  }
  av(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.yu();
    var composite = decoder.xy(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
      var klassName = null;
      var value = null;
      if (composite.nz()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.oz(this.yu());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.hz(this.yu(), index);
            break;
          case 1:
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              var value_0 = klassName;
              // Inline function 'kotlin.contracts.contract' call
              if (value_0 == null) {
                // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException.l(toString(message));
              } else {
                tmp$ret$2 = value_0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer_0(this, composite, klassName);
            value = composite.kz(this.yu(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException.aw('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        var value_1 = value;
        // Inline function 'kotlin.contracts.contract' call
        if (value_1 == null) {
          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException.l(toString(message_0));
        } else {
          tmp$ret$4 = value_1;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.yy(descriptor);
    return result;
  }
  sv(decoder, klassName) {
    return decoder.mz().w10(this.pv(), klassName);
  }
  tv(encoder, value) {
    return encoder.mz().x10(this.pv(), value);
  }
}
class PolymorphicSerializer extends AbstractPolymorphicSerializer {
  static nv(baseClass) {
    var $this = this.ov();
    $this.kv_1 = baseClass;
    $this.lv_1 = emptyList();
    var tmp = $this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.mv_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda($this));
    return $this;
  }
  pv() {
    return this.kv_1;
  }
  static qv(baseClass, classAnnotations) {
    var $this = this.nv(baseClass);
    $this.lv_1 = asList(classAnnotations);
    return $this;
  }
  yu() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.mv_1;
    descriptor$factory();
    return this_0.w1();
  }
  toString() {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.kv_1) + ')';
  }
}
class SealedClassSerializer extends AbstractPolymorphicSerializer {
  yu() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.uv_1;
    descriptor$factory_0();
    return this_0.w1();
  }
}
class SerializationException extends IllegalArgumentException {
  static zv() {
    var $this = this.re();
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
  static aw(message) {
    var $this = this.l(message);
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
  static bw(message, cause) {
    var $this = this.te(message, cause);
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
}
class UnknownFieldException extends SerializationException {
  static hw(message) {
    var $this = this.aw(message);
    captureStack($this, $this.gw_1);
    return $this;
  }
  static iw(index) {
    return this.hw('An unknown field for index ' + index);
  }
}
class MissingFieldException extends SerializationException {
  static pw(missingFields, message, cause) {
    var $this = this.bw(message, cause);
    captureStack($this, $this.ow_1);
    $this.nw_1 = missingFields;
    return $this;
  }
  static qw(missingFields, serialName) {
    return this.pw(missingFields, missingFields.g1() === 1 ? "Field '" + missingFields.h1(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
  }
}
class SerialDescriptor {}
function get_isNullable() {
  return false;
}
function get_isInline() {
  return false;
}
function get_annotations() {
  return emptyList();
}
class ContextDescriptor {
  constructor(original, kClass) {
    this.xw_1 = original;
    this.yw_1 = kClass;
    this.zw_1 = this.xw_1.ax() + '<' + this.yw_1.yf() + '>';
  }
  bx(index) {
    return this.xw_1.bx(index);
  }
  cx(name) {
    return this.xw_1.cx(name);
  }
  dx(index) {
    return this.xw_1.dx(index);
  }
  ex(index) {
    return this.xw_1.ex(index);
  }
  fx(index) {
    return this.xw_1.fx(index);
  }
  gx() {
    return this.xw_1.gx();
  }
  ww() {
    return this.xw_1.ww();
  }
  hx() {
    return this.xw_1.hx();
  }
  ix() {
    return this.xw_1.ix();
  }
  jx() {
    return this.xw_1.jx();
  }
  ax() {
    return this.zw_1;
  }
  equals(other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.xw_1, another.xw_1) && another.yw_1.equals(this.yw_1);
  }
  hashCode() {
    var result = this.yw_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.zw_1) | 0;
    return result;
  }
  toString() {
    return 'ContextDescriptor(kClass: ' + toString(this.yw_1) + ', original: ' + toString(this.xw_1) + ')';
  }
}
class elementDescriptors$1 {
  constructor($this_elementDescriptors) {
    this.ox_1 = $this_elementDescriptors;
    this.nx_1 = $this_elementDescriptors.ix();
  }
  c1() {
    return this.nx_1 > 0;
  }
  d1() {
    var tmp = this.ox_1.ix();
    var _unary__edvuaz = this.nx_1;
    this.nx_1 = _unary__edvuaz - 1 | 0;
    return this.ox_1.ex(tmp - _unary__edvuaz | 0);
  }
}
class _no_name_provided__qut3iv {
  constructor($this_elementDescriptors) {
    this.px_1 = $this_elementDescriptors;
  }
  b1() {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
    return new elementDescriptors$1(this.px_1);
  }
}
class elementNames$1 {
  constructor($this_elementNames) {
    this.rx_1 = $this_elementNames;
    this.qx_1 = $this_elementNames.ix();
  }
  c1() {
    return this.qx_1 > 0;
  }
  d1() {
    var tmp = this.rx_1.ix();
    var _unary__edvuaz = this.qx_1;
    this.qx_1 = _unary__edvuaz - 1 | 0;
    return this.rx_1.bx(tmp - _unary__edvuaz | 0);
  }
}
class _no_name_provided__qut3iv_0 {
  constructor($this_elementNames) {
    this.sx_1 = $this_elementNames;
  }
  b1() {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementNames>.<anonymous>' call
    return new elementNames$1(this.sx_1);
  }
}
class ClassSerialDescriptorBuilder {
  constructor(serialName) {
    this.bv_1 = serialName;
    this.cv_1 = false;
    this.dv_1 = emptyList();
    this.ev_1 = ArrayList.z();
    this.fv_1 = HashSet.va();
    this.gv_1 = ArrayList.z();
    this.hv_1 = ArrayList.z();
    this.iv_1 = ArrayList.z();
  }
  tx(elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.fv_1.h(elementName)) {
      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
      var message = "Element with name '" + elementName + "' is already registered in " + this.bv_1;
      throw IllegalArgumentException.l(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.ev_1.h(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.gv_1.h(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.hv_1.h(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.iv_1.h(isOptional);
  }
  jv(elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.tx(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.tx.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  }
}
class CachedNames {}
class SerialDescriptorImpl {
  constructor(serialName, kind, elementsCount, typeParameters, builder) {
    this.ux_1 = serialName;
    this.vx_1 = kind;
    this.wx_1 = elementsCount;
    this.xx_1 = builder.dv_1;
    this.yx_1 = toHashSet(builder.ev_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.ev_1;
    tmp.zx_1 = copyToArray(this_0);
    this.ay_1 = compactArray(builder.gv_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.hv_1;
    tmp_0.by_1 = copyToArray(this_1);
    this.cy_1 = toBooleanArray(builder.iv_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.zx_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
      var tmp$ret$2 = to(item.dm_1, item.cm_1);
      destination.h(tmp$ret$2);
    }
    tmp_1.dy_1 = toMap(destination);
    this.ey_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.fy_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  ax() {
    return this.ux_1;
  }
  gx() {
    return this.vx_1;
  }
  ix() {
    return this.wx_1;
  }
  jx() {
    return this.xx_1;
  }
  gy() {
    return this.yx_1;
  }
  bx(index) {
    return getChecked(this.zx_1, index);
  }
  cx(name) {
    var tmp0_elvis_lhs = this.dy_1.e3(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  dx(index) {
    return getChecked(this.by_1, index);
  }
  ex(index) {
    return getChecked(this.ay_1, index);
  }
  fx(index) {
    return getChecked_0(this.cy_1, index);
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ax() === other.ax())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
      if (!contentEquals(this.ey_1, other.ey_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ix() === other.ix())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.ix();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.ex(index).ax() === other.ex(index).ax())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.ex(index).gx(), other.ex(index).gx())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    return _get__hashCode__tgwhef(this);
  }
  toString() {
    var tmp = until(0, this.wx_1);
    var tmp_0 = this.ux_1 + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  }
}
class SerialKind {
  toString() {
    return ensureNotNull(getKClassFromExpression(this).yf());
  }
  hashCode() {
    return getStringHashCode(this.toString());
  }
}
class ENUM extends SerialKind {
  constructor() {
    ENUM_instance = null;
    super();
    ENUM_instance = this;
  }
}
class CONTEXTUAL extends SerialKind {
  constructor() {
    CONTEXTUAL_instance = null;
    super();
    CONTEXTUAL_instance = this;
  }
}
class PolymorphicKind extends SerialKind {}
class SEALED extends PolymorphicKind {
  constructor() {
    SEALED_instance = null;
    super();
    SEALED_instance = this;
  }
}
class OPEN extends PolymorphicKind {
  constructor() {
    OPEN_instance = null;
    super();
    OPEN_instance = this;
  }
}
class PrimitiveKind extends SerialKind {}
class BOOLEAN extends PrimitiveKind {
  constructor() {
    BOOLEAN_instance = null;
    super();
    BOOLEAN_instance = this;
  }
}
class BYTE extends PrimitiveKind {
  constructor() {
    BYTE_instance = null;
    super();
    BYTE_instance = this;
  }
}
class CHAR extends PrimitiveKind {
  constructor() {
    CHAR_instance = null;
    super();
    CHAR_instance = this;
  }
}
class SHORT extends PrimitiveKind {
  constructor() {
    SHORT_instance = null;
    super();
    SHORT_instance = this;
  }
}
class INT extends PrimitiveKind {
  constructor() {
    INT_instance = null;
    super();
    INT_instance = this;
  }
}
class LONG extends PrimitiveKind {
  constructor() {
    LONG_instance = null;
    super();
    LONG_instance = this;
  }
}
class FLOAT extends PrimitiveKind {
  constructor() {
    FLOAT_instance = null;
    super();
    FLOAT_instance = this;
  }
}
class DOUBLE extends PrimitiveKind {
  constructor() {
    DOUBLE_instance = null;
    super();
    DOUBLE_instance = this;
  }
}
class STRING extends PrimitiveKind {
  constructor() {
    STRING_instance = null;
    super();
    STRING_instance = this;
  }
}
class StructureKind extends SerialKind {}
class CLASS extends StructureKind {
  constructor() {
    CLASS_instance = null;
    super();
    CLASS_instance = this;
  }
}
class LIST extends StructureKind {
  constructor() {
    LIST_instance = null;
    super();
    LIST_instance = this;
  }
}
class MAP extends StructureKind {
  constructor() {
    MAP_instance = null;
    super();
    MAP_instance = this;
  }
}
class OBJECT extends StructureKind {
  constructor() {
    OBJECT_instance = null;
    super();
    OBJECT_instance = this;
  }
}
class Decoder {}
function decodeSerializableValue(deserializer) {
  return deserializer.av(this);
}
class CompositeDecoder {}
function decodeSequentially() {
  return false;
}
function decodeCollectionSize(descriptor) {
  return -1;
}
function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
  previousValue = previousValue === VOID ? null : previousValue;
  return $super === VOID ? this.jz(descriptor, index, deserializer, previousValue) : $super.jz.call(this, descriptor, index, deserializer, previousValue);
}
class AbstractDecoder {
  hy() {
    throw SerializationException.aw(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  }
  iy() {
    return true;
  }
  jy() {
    return null;
  }
  ky() {
    var tmp = this.hy();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  }
  ly() {
    var tmp = this.hy();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  my() {
    var tmp = this.hy();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  ny() {
    var tmp = this.hy();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  oy() {
    var tmp = this.hy();
    return tmp instanceof Long ? tmp : THROW_CCE();
  }
  py() {
    var tmp = this.hy();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  qy() {
    var tmp = this.hy();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  ry() {
    var tmp = this.hy();
    return tmp instanceof Char ? tmp.n2_1 : THROW_CCE();
  }
  sy() {
    var tmp = this.hy();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  }
  ty(enumDescriptor) {
    var tmp = this.hy();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  uy(descriptor) {
    return this;
  }
  vy(deserializer, previousValue) {
    return this.wy(deserializer);
  }
  xy(descriptor) {
    return this;
  }
  yy(descriptor) {
  }
  zy(descriptor, index) {
    return this.ky();
  }
  az(descriptor, index) {
    return this.ly();
  }
  bz(descriptor, index) {
    return this.my();
  }
  cz(descriptor, index) {
    return this.ny();
  }
  dz(descriptor, index) {
    return this.oy();
  }
  ez(descriptor, index) {
    return this.py();
  }
  fz(descriptor, index) {
    return this.qy();
  }
  gz(descriptor, index) {
    return this.ry();
  }
  hz(descriptor, index) {
    return this.sy();
  }
  iz(descriptor, index) {
    return this.uy(descriptor.ex(index));
  }
  jz(descriptor, index, deserializer, previousValue) {
    return this.vy(deserializer, previousValue);
  }
  lz(descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = deserializer.yu().ww();
    var tmp;
    if (isNullabilitySupported || this.iy()) {
      // Inline function 'kotlinx.serialization.encoding.AbstractDecoder.decodeNullableSerializableElement.<anonymous>' call
      tmp = this.vy(deserializer, previousValue);
    } else {
      tmp = this.jy();
    }
    return tmp;
  }
}
class Encoder {}
function encodeNotNullMark() {
}
function beginCollection(descriptor, collectionSize) {
  return this.xy(descriptor);
}
function encodeSerializableValue(serializer, value) {
  serializer.zu(this, value);
}
function encodeNullableSerializableValue(serializer, value) {
  var isNullabilitySupported = serializer.yu().ww();
  if (isNullabilitySupported) {
    return this.q10(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
  }
  if (value == null) {
    this.tz();
  } else {
    this.t10();
    this.q10(serializer, value);
  }
}
class CompositeEncoder {}
function shouldEncodeElementDefault(descriptor, index) {
  return true;
}
class AbstractEncoder {
  static qz() {
    return createThis(this);
  }
  xy(descriptor) {
    return this;
  }
  yy(descriptor) {
  }
  rz(descriptor, index) {
    return true;
  }
  sz(value) {
    throw SerializationException.aw('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
  }
  tz() {
    throw SerializationException.aw("'null' is not supported by default");
  }
  uz(value) {
    return this.sz(value);
  }
  vz(value) {
    return this.sz(value);
  }
  wz(value) {
    return this.sz(value);
  }
  xz(value) {
    return this.sz(value);
  }
  yz(value) {
    return this.sz(value);
  }
  zz(value) {
    return this.sz(value);
  }
  a10(value) {
    return this.sz(value);
  }
  b10(value) {
    return this.sz(new Char(value));
  }
  c10(value) {
    return this.sz(value);
  }
  d10(enumDescriptor, index) {
    return this.sz(index);
  }
  e10(descriptor) {
    return this;
  }
  f10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.uz(value);
    }
  }
  g10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.vz(value);
    }
  }
  h10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.wz(value);
    }
  }
  i10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.xz(value);
    }
  }
  j10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.yz(value);
    }
  }
  k10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.zz(value);
    }
  }
  l10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.a10(value);
    }
  }
  m10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.b10(value);
    }
  }
  n10(descriptor, index, value) {
    if (this.rz(descriptor, index)) {
      this.c10(value);
    }
  }
  o10(descriptor, index) {
    return this.rz(descriptor, index) ? this.e10(descriptor.ex(index)) : NoOpEncoder_getInstance();
  }
  p10(descriptor, index, serializer, value) {
    if (this.rz(descriptor, index)) {
      this.q10(serializer, value);
    }
  }
  r10(descriptor, index, serializer, value) {
    if (this.rz(descriptor, index)) {
      this.s10(serializer, value);
    }
  }
}
class NothingSerializer {
  constructor() {
    NothingSerializer_instance = this;
    this.y10_1 = NothingSerialDescriptor_getInstance();
  }
  yu() {
    return this.y10_1;
  }
  z10(encoder, value) {
    throw SerializationException.aw("'kotlin.Nothing' cannot be serialized");
  }
  zu(encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.z10(encoder, tmp);
  }
  av(decoder) {
    throw SerializationException.aw("'kotlin.Nothing' does not have instances");
  }
}
class DurationSerializer {
  constructor() {
    DurationSerializer_instance = this;
    this.a11_1 = new PrimitiveSerialDescriptor('kotlin.time.Duration', STRING_getInstance());
  }
  yu() {
    return this.a11_1;
  }
  b11(encoder, value) {
    encoder.c10(Duration__toIsoString_impl_9h6wsm(value));
  }
  zu(encoder, value) {
    return this.b11(encoder, value instanceof Duration ? value.lk_1 : THROW_CCE());
  }
  c11(decoder) {
    return Companion_getInstance().ls(decoder.sy());
  }
  av(decoder) {
    return new Duration(this.c11(decoder));
  }
}
class ListLikeDescriptor {
  constructor(elementDescriptor) {
    this.f11_1 = elementDescriptor;
    this.g11_1 = 1;
  }
  gx() {
    return LIST_getInstance();
  }
  ix() {
    return this.g11_1;
  }
  bx(index) {
    return index.toString();
  }
  cx(name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  fx(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ax() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return false;
  }
  dx(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ax() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return emptyList();
  }
  ex(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ax() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return this.f11_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.f11_1, other.f11_1) && this.ax() === other.ax())
      return true;
    return false;
  }
  hashCode() {
    return imul(hashCode(this.f11_1), 31) + getStringHashCode(this.ax()) | 0;
  }
  toString() {
    return this.ax() + '(' + toString(this.f11_1) + ')';
  }
}
class ArrayListClassDesc extends ListLikeDescriptor {
  ax() {
    return 'kotlin.collections.ArrayList';
  }
}
class HashSetClassDesc extends ListLikeDescriptor {
  ax() {
    return 'kotlin.collections.HashSet';
  }
}
class LinkedHashSetClassDesc extends ListLikeDescriptor {
  ax() {
    return 'kotlin.collections.LinkedHashSet';
  }
}
class MapLikeDescriptor {
  constructor(serialName, keyDescriptor, valueDescriptor) {
    this.l11_1 = serialName;
    this.m11_1 = keyDescriptor;
    this.n11_1 = valueDescriptor;
    this.o11_1 = 2;
  }
  ax() {
    return this.l11_1;
  }
  gx() {
    return MAP_getInstance();
  }
  ix() {
    return this.o11_1;
  }
  bx(index) {
    return index.toString();
  }
  cx(name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  fx(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ax() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return false;
  }
  dx(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ax() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return emptyList();
  }
  ex(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ax() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.m11_1;
        break;
      case 1:
        tmp = this.n11_1;
        break;
      default:
        var message_0 = 'Unreached';
        throw IllegalStateException.h5(toString(message_0));
    }
    return tmp;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.ax() === other.ax()))
      return false;
    if (!equals(this.m11_1, other.m11_1))
      return false;
    if (!equals(this.n11_1, other.n11_1))
      return false;
    return true;
  }
  hashCode() {
    var result = getStringHashCode(this.ax());
    result = imul(31, result) + hashCode(this.m11_1) | 0;
    result = imul(31, result) + hashCode(this.n11_1) | 0;
    return result;
  }
  toString() {
    return this.ax() + '(' + toString(this.m11_1) + ', ' + toString(this.n11_1) + ')';
  }
}
class HashMapClassDesc extends MapLikeDescriptor {
  constructor(keyDesc, valueDesc) {
    super('kotlin.collections.HashMap', keyDesc, valueDesc);
  }
}
class LinkedHashMapClassDesc extends MapLikeDescriptor {
  constructor(keyDesc, valueDesc) {
    super('kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
}
class ArrayClassDesc extends ListLikeDescriptor {
  ax() {
    return 'kotlin.Array';
  }
}
class PrimitiveArrayDescriptor extends ListLikeDescriptor {
  constructor(primitive) {
    super(primitive);
    this.t11_1 = primitive.ax() + 'Array';
  }
  ax() {
    return this.t11_1;
  }
}
class AbstractCollectionSerializer {
  p12(decoder, previous) {
    var tmp0_elvis_lhs = previous == null ? null : this.c12(previous);
    var builder = tmp0_elvis_lhs == null ? this.w11() : tmp0_elvis_lhs;
    var startIndex = this.y11(builder);
    var compositeDecoder = decoder.xy(this.yu());
    if (compositeDecoder.nz()) {
      this.m12(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.oz(this.yu());
        if (index === -1)
          break $l$loop;
        this.o12(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.yy(this.yu());
    return this.a12(builder);
  }
  av(decoder) {
    return this.p12(decoder, null);
  }
  o12(decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.n12(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.n12.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  }
}
class CollectionLikeSerializer extends AbstractCollectionSerializer {
  constructor(elementSerializer) {
    super();
    this.k12_1 = elementSerializer;
  }
  l12(encoder, value) {
    var size = this.h13(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.yu();
    var composite = encoder.u10(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
    var iterator = this.j13(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.p10(this.yu(), index, this.k12_1, iterator.d1());
      }
       while (inductionVariable < size);
    composite.yy(descriptor);
  }
  zu(encoder, value) {
    return this.l12(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  m12(decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException.l(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.n12(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  }
  n12(decoder, index, builder, checkIndex) {
    this.g12(builder, index, decoder.kz(this.yu(), index, this.k12_1));
  }
}
class CollectionSerializer extends CollectionLikeSerializer {
  i12(_this__u8e3s4) {
    return _this__u8e3s4.g1();
  }
  h13(_this__u8e3s4) {
    return this.i12((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  j12(_this__u8e3s4) {
    return _this__u8e3s4.b1();
  }
  j13(_this__u8e3s4) {
    return this.j12((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  }
}
class ArrayListSerializer extends CollectionSerializer {
  constructor(element) {
    super(element);
    this.v11_1 = new ArrayListClassDesc(element.yu());
  }
  yu() {
    return this.v11_1;
  }
  w11() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList.z();
  }
  x11(_this__u8e3s4) {
    return _this__u8e3s4.g1();
  }
  y11(_this__u8e3s4) {
    return this.x11(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  z11(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  a12(_this__u8e3s4) {
    return this.z11(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  b12(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList.v(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  c12(_this__u8e3s4) {
    return this.b12((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  d12(_this__u8e3s4, size) {
    return _this__u8e3s4.n8(size);
  }
  e12(_this__u8e3s4, size) {
    return this.d12(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  }
  f12(_this__u8e3s4, index, element) {
    _this__u8e3s4.n7(index, element);
  }
  g12(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.f12(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class HashSetSerializer extends CollectionSerializer {
  constructor(eSerializer) {
    super(eSerializer);
    this.r12_1 = new HashSetClassDesc(eSerializer.yu());
  }
  yu() {
    return this.r12_1;
  }
  w11() {
    return HashSet.va();
  }
  s12(_this__u8e3s4) {
    return _this__u8e3s4.g1();
  }
  y11(_this__u8e3s4) {
    return this.s12(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  }
  t12(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  a12(_this__u8e3s4) {
    return this.t12(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  }
  u12(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet.wa(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  c12(_this__u8e3s4) {
    return this.u12((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  v12(_this__u8e3s4, size) {
  }
  e12(_this__u8e3s4, size) {
    return this.v12(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  }
  w12(_this__u8e3s4, index, element) {
    _this__u8e3s4.h(element);
  }
  g12(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
    return this.w12(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class LinkedHashSetSerializer extends CollectionSerializer {
  constructor(eSerializer) {
    super(eSerializer);
    this.y12_1 = new LinkedHashSetClassDesc(eSerializer.yu());
  }
  yu() {
    return this.y12_1;
  }
  w11() {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet.r1();
  }
  z12(_this__u8e3s4) {
    return _this__u8e3s4.g1();
  }
  y11(_this__u8e3s4) {
    return this.z12(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  }
  a13(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  a12(_this__u8e3s4) {
    return this.a13(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  }
  u12(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet.s1(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  c12(_this__u8e3s4) {
    return this.u12((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  b13(_this__u8e3s4, size) {
  }
  e12(_this__u8e3s4, size) {
    return this.b13(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  }
  c13(_this__u8e3s4, index, element) {
    _this__u8e3s4.h(element);
  }
  g12(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.c13(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class MapLikeSerializer extends AbstractCollectionSerializer {
  constructor(keySerializer, valueSerializer) {
    super();
    this.o13_1 = keySerializer;
    this.p13_1 = valueSerializer;
  }
  q13(decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException.l(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.f2_1;
    var last = progression.g2_1;
    var step_0 = progression.h2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.r13(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  }
  m12(decoder, builder, startIndex, size) {
    return this.q13(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  }
  r13(decoder, index, builder, checkIndex) {
    var key = decoder.kz(this.yu(), index, this.o13_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.oz(this.yu());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this_0 === (index + 1 | 0))) {
        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException.l(toString(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.c3(key)) {
      var tmp_2 = this.p13_1.yu().gx();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.jz(this.yu(), vIndex, this.p13_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.kz(this.yu(), vIndex, this.p13_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.k3(key, value);
  }
  n12(decoder, index, builder, checkIndex) {
    return this.r13(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  }
  l12(encoder, value) {
    var size = this.h13(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.yu();
    var composite = encoder.u10(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
    var iterator = this.j13(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = iterator;
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.v1();
      // Inline function 'kotlin.collections.component2' call
      var v = element.w1();
      var tmp = this.yu();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      composite.p10(tmp, _unary__edvuaz, this.o13_1, k);
      var tmp_0 = this.yu();
      var _unary__edvuaz_0 = index;
      index = _unary__edvuaz_0 + 1 | 0;
      composite.p10(tmp_0, _unary__edvuaz_0, this.p13_1, v);
    }
    composite.yy(descriptor);
  }
  zu(encoder, value) {
    return this.l12(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
}
class HashMapSerializer extends MapLikeSerializer {
  constructor(kSerializer, vSerializer) {
    super(kSerializer, vSerializer);
    this.f13_1 = new HashMapClassDesc(kSerializer.yu(), vSerializer.yu());
  }
  yu() {
    return this.f13_1;
  }
  g13(_this__u8e3s4) {
    return _this__u8e3s4.g1();
  }
  h13(_this__u8e3s4) {
    return this.g13((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  i13(_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.u1().b1();
  }
  j13(_this__u8e3s4) {
    return this.i13((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  w11() {
    return HashMap.a9();
  }
  k13(_this__u8e3s4) {
    return imul(_this__u8e3s4.g1(), 2);
  }
  y11(_this__u8e3s4) {
    return this.k13(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  }
  l13(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  a12(_this__u8e3s4) {
    return this.l13(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  }
  m13(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap.p9(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  c12(_this__u8e3s4) {
    return this.m13((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n13(_this__u8e3s4, size) {
  }
  e12(_this__u8e3s4, size) {
    return this.n13(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  }
}
class LinkedHashMapSerializer extends MapLikeSerializer {
  constructor(kSerializer, vSerializer) {
    super(kSerializer, vSerializer);
    this.u13_1 = new LinkedHashMapClassDesc(kSerializer.yu(), vSerializer.yu());
  }
  yu() {
    return this.u13_1;
  }
  g13(_this__u8e3s4) {
    return _this__u8e3s4.g1();
  }
  h13(_this__u8e3s4) {
    return this.g13((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  i13(_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.u1().b1();
  }
  j13(_this__u8e3s4) {
    return this.i13((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  w11() {
    return LinkedHashMap.wc();
  }
  v13(_this__u8e3s4) {
    return imul(_this__u8e3s4.g1(), 2);
  }
  y11(_this__u8e3s4) {
    return this.v13(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  }
  w13(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  a12(_this__u8e3s4) {
    return this.w13(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  }
  m13(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap.yc(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  c12(_this__u8e3s4) {
    return this.m13((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  x13(_this__u8e3s4, size) {
  }
  e12(_this__u8e3s4, size) {
    return this.x13(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  }
}
class ReferenceArraySerializer extends CollectionLikeSerializer {
  constructor(kClass, eSerializer) {
    super(eSerializer);
    this.z13_1 = kClass;
    this.a14_1 = new ArrayClassDesc(eSerializer.yu());
  }
  yu() {
    return this.a14_1;
  }
  b14(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.b14((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  c14(_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  }
  j13(_this__u8e3s4) {
    return this.c14((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  w11() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList.z();
  }
  d14(_this__u8e3s4) {
    return _this__u8e3s4.g1();
  }
  y11(_this__u8e3s4) {
    return this.d14(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  e14(_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.z13_1);
  }
  a12(_this__u8e3s4) {
    return this.e14(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  f14(_this__u8e3s4) {
    return ArrayList.v(asList(_this__u8e3s4));
  }
  c12(_this__u8e3s4) {
    return this.f14((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  g14(_this__u8e3s4, size) {
    return _this__u8e3s4.n8(size);
  }
  e12(_this__u8e3s4, size) {
    return this.g14(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  }
  h14(_this__u8e3s4, index, element) {
    _this__u8e3s4.n7(index, element);
  }
  g12(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.h14(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class PrimitiveArraySerializer extends CollectionLikeSerializer {
  constructor(primitiveSerializer) {
    super(primitiveSerializer);
    this.j14_1 = new PrimitiveArrayDescriptor(primitiveSerializer.yu());
  }
  yu() {
    return this.j14_1;
  }
  k14(_this__u8e3s4) {
    return _this__u8e3s4.l14();
  }
  y11(_this__u8e3s4) {
    return this.k14(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  }
  m14(_this__u8e3s4) {
    return _this__u8e3s4.n14();
  }
  a12(_this__u8e3s4) {
    return this.m14(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  }
  o14(_this__u8e3s4, size) {
    return _this__u8e3s4.p14(size);
  }
  e12(_this__u8e3s4, size) {
    return this.o14(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  }
  q14(_this__u8e3s4) {
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException.h5(toString(message));
  }
  j13(_this__u8e3s4) {
    return this.q14((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
  }
  r14(_this__u8e3s4, index, element) {
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException.h5(toString(message));
  }
  g12(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
    return this.r14(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  w11() {
    return this.c12(this.s14());
  }
  v14(encoder, value) {
    var size = this.h13(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.j14_1;
    var composite = encoder.u10(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
    this.u14(composite, value, size);
    composite.yy(descriptor);
  }
  zu(encoder, value) {
    return this.v14(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  l12(encoder, value) {
    return this.v14(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  av(decoder) {
    return this.p12(decoder, null);
  }
}
class PrimitiveArrayBuilder {
  w14(requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.l14() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.p14(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.p14.call(this, requiredCapacity);
    }
    return tmp;
  }
}
class Companion {
  constructor() {
    Companion_instance_0 = this;
    this.x14_1 = longArray(0);
  }
}
class ElementMarker {
  constructor(descriptor, readIfAbsent) {
    Companion_getInstance_6();
    this.y14_1 = descriptor;
    this.z14_1 = readIfAbsent;
    var elementsCount = this.y14_1.ix();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = (new Long(-1, -1)).e4(elementsCount);
      }
      tmp.a15_1 = tmp_0;
      this.b15_1 = Companion_getInstance_6().x14_1;
    } else {
      this.a15_1 = new Long(0, 0);
      this.b15_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  c15(index) {
    if (index < 64) {
      this.a15_1 = this.a15_1.i4((new Long(1, 0)).e4(index));
    } else {
      markHigh(this, index);
    }
  }
  d15() {
    var elementsCount = this.y14_1.ix();
    while (!this.a15_1.equals(new Long(-1, -1))) {
      var index = countTrailingZeroBits(this.a15_1.d4());
      this.a15_1 = this.a15_1.i4((new Long(1, 0)).e4(index));
      if (this.z14_1(this.y14_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  }
}
class EnumSerializer {
  static h15(serialName, values) {
    var $this = createThis(this);
    $this.e15_1 = values;
    $this.f15_1 = null;
    var tmp = $this;
    tmp.g15_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda($this, serialName));
    return $this;
  }
  static v15(serialName, values, descriptor) {
    var $this = this.h15(serialName, values);
    $this.f15_1 = descriptor;
    return $this;
  }
  yu() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g15_1;
    descriptor$factory_1();
    return this_0.w1();
  }
  w15(encoder, value) {
    var index = indexOf(this.e15_1, value);
    if (index === -1) {
      throw SerializationException.aw(toString(value) + ' is not a valid enum ' + this.yu().ax() + ', ' + ('must be one of ' + contentToString(this.e15_1)));
    }
    encoder.d10(this.yu(), index);
  }
  zu(encoder, value) {
    return this.w15(encoder, value instanceof Enum ? value : THROW_CCE());
  }
  av(decoder) {
    var index = decoder.ty(this.yu());
    if (!(0 <= index ? index <= (this.e15_1.length - 1 | 0) : false)) {
      throw SerializationException.aw('' + index + ' is not among valid ' + this.yu().ax() + ' enum values, ' + ('values size is ' + this.e15_1.length));
    }
    return this.e15_1[index];
  }
  toString() {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.yu().ax() + '>';
  }
}
class PluginGeneratedSerialDescriptor {
  constructor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.i15_1 = serialName;
    this.j15_1 = generatedSerializer;
    this.k15_1 = elementsCount;
    this.l15_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.k15_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.m15_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.k15_1;
    tmp_3.n15_1 = fillArrayVal(Array(size), null);
    this.o15_1 = null;
    this.p15_1 = booleanArray(this.k15_1);
    this.q15_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.r15_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.s15_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.t15_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  ax() {
    return this.i15_1;
  }
  ix() {
    return this.k15_1;
  }
  gx() {
    return CLASS_getInstance();
  }
  jx() {
    var tmp0_elvis_lhs = this.o15_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  gy() {
    return this.q15_1.f3();
  }
  l16() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s15_1;
    typeParameterDescriptors$factory();
    return this_0.w1();
  }
  m16(name, isOptional) {
    this.l15_1 = this.l15_1 + 1 | 0;
    this.m15_1[this.l15_1] = name;
    this.p15_1[this.l15_1] = isOptional;
    this.n15_1[this.l15_1] = null;
    if (this.l15_1 === (this.k15_1 - 1 | 0)) {
      this.q15_1 = buildIndices(this);
    }
  }
  u15(name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.m16(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.m16.call(this, name, isOptional);
    }
    return tmp;
  }
  n16(annotation) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.pushAnnotation.<anonymous>' call
    var it = this.n15_1[this.l15_1];
    var tmp;
    if (it == null) {
      var result = ArrayList.w(1);
      this.n15_1[this.l15_1] = result;
      tmp = result;
    } else {
      tmp = it;
    }
    var list = tmp;
    list.h(annotation);
  }
  o16(a) {
    if (this.o15_1 == null) {
      this.o15_1 = ArrayList.w(1);
    }
    ensureNotNull(this.o15_1).h(a);
  }
  ex(index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).yu();
  }
  fx(index) {
    return getChecked_0(this.p15_1, index);
  }
  dx(index) {
    var tmp0_elvis_lhs = getChecked(this.n15_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  bx(index) {
    return getChecked(this.m15_1, index);
  }
  cx(name) {
    var tmp0_elvis_lhs = this.q15_1.e3(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ax() === other.ax())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
      if (!contentEquals(this.l16(), other.l16())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ix() === other.ix())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.ix();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.ex(index).ax() === other.ex(index).ax())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.ex(index).gx(), other.ex(index).gx())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    return _get__hashCode__tgwhef_0(this);
  }
  toString() {
    var tmp = until(0, this.k15_1);
    var tmp_0 = this.ax() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  }
}
class EnumDescriptor extends PluginGeneratedSerialDescriptor {
  constructor(name, elementsCount) {
    super(name, VOID, elementsCount);
    this.j16_1 = ENUM_getInstance();
    var tmp = this;
    tmp.k16_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  gx() {
    return this.j16_1;
  }
  ex(index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.gx() === ENUM_getInstance()))
      return false;
    if (!(this.ax() === other.ax()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  }
  toString() {
    return joinToString(get_elementNames(this), ', ', this.ax() + '(', ')');
  }
  hashCode() {
    var result = getStringHashCode(this.ax());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = get_elementNames(this).b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.EnumDescriptor.hashCode.<anonymous>' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  }
}
class InlineClassDescriptor extends PluginGeneratedSerialDescriptor {
  constructor(name, generatedSerializer) {
    super(name, generatedSerializer, 1);
    this.b17_1 = true;
  }
  hx() {
    return this.b17_1;
  }
  hashCode() {
    return imul(super.hashCode(), 31);
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ax() === other.ax())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
      if (!(other.b17_1 && contentEquals(this.l16(), other.l16()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ix() === other.ix())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.ix();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.ex(index).ax() === other.ex(index).ax())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.ex(index).gx(), other.ex(index).gx())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
}
class GeneratedSerializer {}
function typeParametersSerializers() {
  return get_EMPTY_SERIALIZER_ARRAY();
}
class InlinePrimitiveDescriptor$1 {
  constructor($primitiveSerializer) {
    this.c17_1 = $primitiveSerializer;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.c17_1];
  }
  yu() {
    var message = 'unsupported';
    throw IllegalStateException.h5(toString(message));
  }
  zu(encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException.h5(toString(message));
  }
  av(decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException.h5(toString(message));
  }
}
class NoOpEncoder extends AbstractEncoder {
  static g17() {
    NoOpEncoder_instance = null;
    var $this = this.qz();
    NoOpEncoder_instance = $this;
    $this.f17_1 = EmptySerializersModule_0();
    return $this;
  }
  mz() {
    return this.f17_1;
  }
  sz(value) {
    return Unit_instance;
  }
  tz() {
    return Unit_instance;
  }
  uz(value) {
    return Unit_instance;
  }
  vz(value) {
    return Unit_instance;
  }
  wz(value) {
    return Unit_instance;
  }
  xz(value) {
    return Unit_instance;
  }
  yz(value) {
    return Unit_instance;
  }
  zz(value) {
    return Unit_instance;
  }
  a10(value) {
    return Unit_instance;
  }
  b10(value) {
    return Unit_instance;
  }
  c10(value) {
    return Unit_instance;
  }
  d10(enumDescriptor, index) {
    return Unit_instance;
  }
}
class NothingSerialDescriptor {
  constructor() {
    NothingSerialDescriptor_instance = this;
    this.h17_1 = OBJECT_getInstance();
    this.i17_1 = 'kotlin.Nothing';
  }
  gx() {
    return this.h17_1;
  }
  ax() {
    return this.i17_1;
  }
  ix() {
    return 0;
  }
  bx(index) {
    error(this);
  }
  cx(name) {
    error(this);
  }
  fx(index) {
    error(this);
  }
  ex(index) {
    error(this);
  }
  dx(index) {
    error(this);
  }
  toString() {
    return 'NothingSerialDescriptor';
  }
  equals(other) {
    return this === other;
  }
  hashCode() {
    return getStringHashCode(this.i17_1) + imul(31, this.h17_1.hashCode()) | 0;
  }
}
class NullableSerializer {
  constructor(serializer) {
    this.j17_1 = serializer;
    this.k17_1 = new SerialDescriptorForNullable(this.j17_1.yu());
  }
  yu() {
    return this.k17_1;
  }
  l17(encoder, value) {
    if (!(value == null)) {
      encoder.t10();
      encoder.q10(this.j17_1, value);
    } else {
      encoder.tz();
    }
  }
  zu(encoder, value) {
    return this.l17(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.iy() ? decoder.wy(this.j17_1) : decoder.jy();
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.j17_1, other.j17_1))
      return false;
    return true;
  }
  hashCode() {
    return hashCode(this.j17_1);
  }
}
class SerialDescriptorForNullable {
  constructor(original) {
    this.kx_1 = original;
    this.lx_1 = this.kx_1.ax() + '?';
    this.mx_1 = cachedSerialNames(this.kx_1);
  }
  bx(index) {
    return this.kx_1.bx(index);
  }
  cx(name) {
    return this.kx_1.cx(name);
  }
  dx(index) {
    return this.kx_1.dx(index);
  }
  ex(index) {
    return this.kx_1.ex(index);
  }
  fx(index) {
    return this.kx_1.fx(index);
  }
  gx() {
    return this.kx_1.gx();
  }
  hx() {
    return this.kx_1.hx();
  }
  ix() {
    return this.kx_1.ix();
  }
  jx() {
    return this.kx_1.jx();
  }
  ax() {
    return this.lx_1;
  }
  gy() {
    return this.mx_1;
  }
  ww() {
    return true;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.kx_1, other.kx_1))
      return false;
    return true;
  }
  toString() {
    return toString(this.kx_1) + '?';
  }
  hashCode() {
    return imul(hashCode(this.kx_1), 31);
  }
}
class ObjectSerializer {
  static p17(serialName, objectInstance) {
    var $this = createThis(this);
    $this.m17_1 = objectInstance;
    $this.n17_1 = emptyList();
    var tmp = $this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o17_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, $this));
    return $this;
  }
  static q17(serialName, objectInstance, classAnnotations) {
    var $this = this.p17(serialName, objectInstance);
    $this.n17_1 = asList(classAnnotations);
    return $this;
  }
  yu() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o17_1;
    descriptor$factory_2();
    return this_0.w1();
  }
  rv(encoder, value) {
    encoder.xy(this.yu()).yy(this.yu());
  }
  zu(encoder, value) {
    return this.rv(encoder, !(value == null) ? value : THROW_CCE());
  }
  av(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.yu();
    var composite = decoder.xy(descriptor);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
      if (composite.nz()) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.oz(this.yu());
      if (index === -1) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException.aw('Unexpected index ' + index);
    }
    var result = tmp$ret$0;
    composite.yy(descriptor);
    return this.m17_1;
  }
}
class SerializerFactory {}
class CharArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    CharArraySerializer_instance = null;
    super(serializer_2(Companion_getInstance_0()));
    CharArraySerializer_instance = this;
  }
  u17(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.u17((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  v17(_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.v17((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s14() {
    return charArray(0);
  }
  w17(decoder, index, builder, checkIndex) {
    builder.z17(decoder.gz(this.j14_1, index));
  }
  n12(decoder, index, builder, checkIndex) {
    return this.w17(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.w17(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  a18(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.m10(this.j14_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.a18(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class DoubleArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    DoubleArraySerializer_instance = null;
    super(serializer_3(DoubleCompanionObject_instance));
    DoubleArraySerializer_instance = this;
  }
  d18(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.d18((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  e18(_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.e18((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s14() {
    return new Float64Array(0);
  }
  f18(decoder, index, builder, checkIndex) {
    builder.i18(decoder.fz(this.j14_1, index));
  }
  n12(decoder, index, builder, checkIndex) {
    return this.f18(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.f18(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  j18(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.l10(this.j14_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.j18(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class FloatArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    FloatArraySerializer_instance = null;
    super(serializer_4(FloatCompanionObject_instance));
    FloatArraySerializer_instance = this;
  }
  m18(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.m18((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n18(_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.n18((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s14() {
    return new Float32Array(0);
  }
  o18(decoder, index, builder, checkIndex) {
    builder.r18(decoder.ez(this.j14_1, index));
  }
  n12(decoder, index, builder, checkIndex) {
    return this.o18(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.o18(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  s18(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.k10(this.j14_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.s18(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class LongArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    LongArraySerializer_instance = null;
    super(serializer_5(Companion_getInstance_1()));
    LongArraySerializer_instance = this;
  }
  v18(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.v18((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  w18(_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.w18((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s14() {
    return longArray(0);
  }
  x18(decoder, index, builder, checkIndex) {
    builder.a19(decoder.dz(this.j14_1, index));
  }
  n12(decoder, index, builder, checkIndex) {
    return this.x18(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.x18(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  b19(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.j10(this.j14_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.b19(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class ULongArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ULongArraySerializer_instance = null;
    super(serializer_6(Companion_getInstance_2()));
    ULongArraySerializer_instance = this;
  }
  e19(_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  }
  h13(_this__u8e3s4) {
    return this.e19(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.a5_1 : THROW_CCE());
  }
  f19(_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.f19(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.a5_1 : THROW_CCE());
  }
  g19() {
    return _ULongArray___init__impl__twm1l3(0);
  }
  s14() {
    return new ULongArray(this.g19());
  }
  h19(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.iz(this.j14_1, index).oy();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.k19(tmp$ret$0);
  }
  n12(decoder, index, builder, checkIndex) {
    return this.h19(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.h19(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  l19(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.o10(this.j14_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.yz(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.l19(encoder, content instanceof ULongArray ? content.a5_1 : THROW_CCE(), size);
  }
}
class IntArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    IntArraySerializer_instance = null;
    super(serializer_7(IntCompanionObject_instance));
    IntArraySerializer_instance = this;
  }
  o19(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.o19((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  p19(_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.p19((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s14() {
    return new Int32Array(0);
  }
  q19(decoder, index, builder, checkIndex) {
    builder.t19(decoder.cz(this.j14_1, index));
  }
  n12(decoder, index, builder, checkIndex) {
    return this.q19(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.q19(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  u19(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.i10(this.j14_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.u19(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UIntArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UIntArraySerializer_instance = null;
    super(serializer_8(Companion_getInstance_3()));
    UIntArraySerializer_instance = this;
  }
  x19(_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  }
  h13(_this__u8e3s4) {
    return this.x19(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.b5_1 : THROW_CCE());
  }
  y19(_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.y19(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.b5_1 : THROW_CCE());
  }
  z19() {
    return _UIntArray___init__impl__ghjpc6(0);
  }
  s14() {
    return new UIntArray(this.z19());
  }
  a1a(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.iz(this.j14_1, index).ny();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.d1a(tmp$ret$0);
  }
  n12(decoder, index, builder, checkIndex) {
    return this.a1a(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.a1a(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  e1a(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.o10(this.j14_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.xz(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.e1a(encoder, content instanceof UIntArray ? content.b5_1 : THROW_CCE(), size);
  }
}
class ShortArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ShortArraySerializer_instance = null;
    super(serializer_9(ShortCompanionObject_instance));
    ShortArraySerializer_instance = this;
  }
  h1a(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.h1a((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  i1a(_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.i1a((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s14() {
    return new Int16Array(0);
  }
  j1a(decoder, index, builder, checkIndex) {
    builder.m1a(decoder.bz(this.j14_1, index));
  }
  n12(decoder, index, builder, checkIndex) {
    return this.j1a(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.j1a(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  n1a(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.h10(this.j14_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.n1a(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UShortArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UShortArraySerializer_instance = null;
    super(serializer_10(Companion_getInstance_4()));
    UShortArraySerializer_instance = this;
  }
  q1a(_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  }
  h13(_this__u8e3s4) {
    return this.q1a(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.c5_1 : THROW_CCE());
  }
  r1a(_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.r1a(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.c5_1 : THROW_CCE());
  }
  s1a() {
    return _UShortArray___init__impl__9b26ef(0);
  }
  s14() {
    return new UShortArray(this.s1a());
  }
  t1a(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.iz(this.j14_1, index).my();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.w1a(tmp$ret$0);
  }
  n12(decoder, index, builder, checkIndex) {
    return this.t1a(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.t1a(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  x1a(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.o10(this.j14_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.wz(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.x1a(encoder, content instanceof UShortArray ? content.c5_1 : THROW_CCE(), size);
  }
}
class ByteArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ByteArraySerializer_instance = null;
    super(serializer_11(ByteCompanionObject_instance));
    ByteArraySerializer_instance = this;
  }
  a1b(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.a1b((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  b1b(_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.b1b((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s14() {
    return new Int8Array(0);
  }
  c1b(decoder, index, builder, checkIndex) {
    builder.f1b(decoder.az(this.j14_1, index));
  }
  n12(decoder, index, builder, checkIndex) {
    return this.c1b(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.c1b(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  g1b(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.g10(this.j14_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.g1b(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UByteArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UByteArraySerializer_instance = null;
    super(serializer_12(Companion_getInstance_5()));
    UByteArraySerializer_instance = this;
  }
  j1b(_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  }
  h13(_this__u8e3s4) {
    return this.j1b(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.d5_1 : THROW_CCE());
  }
  k1b(_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.k1b(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.d5_1 : THROW_CCE());
  }
  l1b() {
    return _UByteArray___init__impl__ip4y9n(0);
  }
  s14() {
    return new UByteArray(this.l1b());
  }
  m1b(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.iz(this.j14_1, index).ly();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.p1b(tmp$ret$0);
  }
  n12(decoder, index, builder, checkIndex) {
    return this.m1b(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.m1b(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  q1b(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.o10(this.j14_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.vz(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.q1b(encoder, content instanceof UByteArray ? content.d5_1 : THROW_CCE(), size);
  }
}
class BooleanArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    BooleanArraySerializer_instance = null;
    super(serializer_13(BooleanCompanionObject_instance));
    BooleanArraySerializer_instance = this;
  }
  t1b(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  h13(_this__u8e3s4) {
    return this.t1b((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  u1b(_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  }
  c12(_this__u8e3s4) {
    return this.u1b((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s14() {
    return booleanArray(0);
  }
  v1b(decoder, index, builder, checkIndex) {
    builder.y1b(decoder.zy(this.j14_1, index));
  }
  n12(decoder, index, builder, checkIndex) {
    return this.v1b(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  t14(decoder, index, builder, checkIndex) {
    return this.v1b(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  z1b(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.f10(this.j14_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  u14(encoder, content, size) {
    return this.z1b(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class CharArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.x17_1 = bufferWithData;
    this.y17_1 = bufferWithData.length;
    this.p14(10);
  }
  l14() {
    return this.y17_1;
  }
  p14(requiredCapacity) {
    if (this.x17_1.length < requiredCapacity)
      this.x17_1 = copyOf(this.x17_1, coerceAtLeast(requiredCapacity, imul(this.x17_1.length, 2)));
  }
  z17(c) {
    this.w14();
    var tmp = this.x17_1;
    var _unary__edvuaz = this.y17_1;
    this.y17_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  n14() {
    return copyOf(this.x17_1, this.y17_1);
  }
}
class DoubleArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.g18_1 = bufferWithData;
    this.h18_1 = bufferWithData.length;
    this.p14(10);
  }
  l14() {
    return this.h18_1;
  }
  p14(requiredCapacity) {
    if (this.g18_1.length < requiredCapacity)
      this.g18_1 = copyOf_0(this.g18_1, coerceAtLeast(requiredCapacity, imul(this.g18_1.length, 2)));
  }
  i18(c) {
    this.w14();
    var tmp = this.g18_1;
    var _unary__edvuaz = this.h18_1;
    this.h18_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  n14() {
    return copyOf_0(this.g18_1, this.h18_1);
  }
}
class FloatArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.p18_1 = bufferWithData;
    this.q18_1 = bufferWithData.length;
    this.p14(10);
  }
  l14() {
    return this.q18_1;
  }
  p14(requiredCapacity) {
    if (this.p18_1.length < requiredCapacity)
      this.p18_1 = copyOf_1(this.p18_1, coerceAtLeast(requiredCapacity, imul(this.p18_1.length, 2)));
  }
  r18(c) {
    this.w14();
    var tmp = this.p18_1;
    var _unary__edvuaz = this.q18_1;
    this.q18_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  n14() {
    return copyOf_1(this.p18_1, this.q18_1);
  }
}
class LongArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.y18_1 = bufferWithData;
    this.z18_1 = bufferWithData.length;
    this.p14(10);
  }
  l14() {
    return this.z18_1;
  }
  p14(requiredCapacity) {
    if (this.y18_1.length < requiredCapacity)
      this.y18_1 = copyOf_2(this.y18_1, coerceAtLeast(requiredCapacity, imul(this.y18_1.length, 2)));
  }
  a19(c) {
    this.w14();
    var tmp = this.y18_1;
    var _unary__edvuaz = this.z18_1;
    this.z18_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  n14() {
    return copyOf_2(this.y18_1, this.z18_1);
  }
}
class ULongArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.i19_1 = bufferWithData;
    this.j19_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.p14(10);
  }
  l14() {
    return this.j19_1;
  }
  p14(requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.i19_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.i19_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.i19_1), 2));
      tmp.i19_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
    }
  }
  k19(c) {
    this.w14();
    var tmp = this.i19_1;
    var _unary__edvuaz = this.j19_1;
    this.j19_1 = _unary__edvuaz + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
  }
  a1c() {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.i19_1;
    var newSize = this.j19_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
  }
  n14() {
    return new ULongArray(this.a1c());
  }
}
class IntArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.r19_1 = bufferWithData;
    this.s19_1 = bufferWithData.length;
    this.p14(10);
  }
  l14() {
    return this.s19_1;
  }
  p14(requiredCapacity) {
    if (this.r19_1.length < requiredCapacity)
      this.r19_1 = copyOf_3(this.r19_1, coerceAtLeast(requiredCapacity, imul(this.r19_1.length, 2)));
  }
  t19(c) {
    this.w14();
    var tmp = this.r19_1;
    var _unary__edvuaz = this.s19_1;
    this.s19_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  n14() {
    return copyOf_3(this.r19_1, this.s19_1);
  }
}
class UIntArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.b1a_1 = bufferWithData;
    this.c1a_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.p14(10);
  }
  l14() {
    return this.c1a_1;
  }
  p14(requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.b1a_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.b1a_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.b1a_1), 2));
      tmp.b1a_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
    }
  }
  d1a(c) {
    this.w14();
    var tmp = this.b1a_1;
    var _unary__edvuaz = this.c1a_1;
    this.c1a_1 = _unary__edvuaz + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
  }
  b1c() {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.b1a_1;
    var newSize = this.c1a_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
  }
  n14() {
    return new UIntArray(this.b1c());
  }
}
class ShortArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.k1a_1 = bufferWithData;
    this.l1a_1 = bufferWithData.length;
    this.p14(10);
  }
  l14() {
    return this.l1a_1;
  }
  p14(requiredCapacity) {
    if (this.k1a_1.length < requiredCapacity)
      this.k1a_1 = copyOf_4(this.k1a_1, coerceAtLeast(requiredCapacity, imul(this.k1a_1.length, 2)));
  }
  m1a(c) {
    this.w14();
    var tmp = this.k1a_1;
    var _unary__edvuaz = this.l1a_1;
    this.l1a_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  n14() {
    return copyOf_4(this.k1a_1, this.l1a_1);
  }
}
class UShortArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.u1a_1 = bufferWithData;
    this.v1a_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.p14(10);
  }
  l14() {
    return this.v1a_1;
  }
  p14(requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.u1a_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.u1a_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.u1a_1), 2));
      tmp.u1a_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
    }
  }
  w1a(c) {
    this.w14();
    var tmp = this.u1a_1;
    var _unary__edvuaz = this.v1a_1;
    this.v1a_1 = _unary__edvuaz + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
  }
  c1c() {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.u1a_1;
    var newSize = this.v1a_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
  }
  n14() {
    return new UShortArray(this.c1c());
  }
}
class ByteArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.d1b_1 = bufferWithData;
    this.e1b_1 = bufferWithData.length;
    this.p14(10);
  }
  l14() {
    return this.e1b_1;
  }
  p14(requiredCapacity) {
    if (this.d1b_1.length < requiredCapacity)
      this.d1b_1 = copyOf_5(this.d1b_1, coerceAtLeast(requiredCapacity, imul(this.d1b_1.length, 2)));
  }
  f1b(c) {
    this.w14();
    var tmp = this.d1b_1;
    var _unary__edvuaz = this.e1b_1;
    this.e1b_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  n14() {
    return copyOf_5(this.d1b_1, this.e1b_1);
  }
}
class UByteArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.n1b_1 = bufferWithData;
    this.o1b_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.p14(10);
  }
  l14() {
    return this.o1b_1;
  }
  p14(requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.n1b_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.n1b_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.n1b_1), 2));
      tmp.n1b_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
    }
  }
  p1b(c) {
    this.w14();
    var tmp = this.n1b_1;
    var _unary__edvuaz = this.o1b_1;
    this.o1b_1 = _unary__edvuaz + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
  }
  d1c() {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.n1b_1;
    var newSize = this.o1b_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
  }
  n14() {
    return new UByteArray(this.d1c());
  }
}
class BooleanArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.w1b_1 = bufferWithData;
    this.x1b_1 = bufferWithData.length;
    this.p14(10);
  }
  l14() {
    return this.x1b_1;
  }
  p14(requiredCapacity) {
    if (this.w1b_1.length < requiredCapacity)
      this.w1b_1 = copyOf_6(this.w1b_1, coerceAtLeast(requiredCapacity, imul(this.w1b_1.length, 2)));
  }
  y1b(c) {
    this.w14();
    var tmp = this.w1b_1;
    var _unary__edvuaz = this.x1b_1;
    this.x1b_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  n14() {
    return copyOf_6(this.w1b_1, this.x1b_1);
  }
}
class StringSerializer {
  constructor() {
    StringSerializer_instance = this;
    this.e1c_1 = new PrimitiveSerialDescriptor('kotlin.String', STRING_getInstance());
  }
  yu() {
    return this.e1c_1;
  }
  f1c(encoder, value) {
    return encoder.c10(value);
  }
  zu(encoder, value) {
    return this.f1c(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.sy();
  }
}
class CharSerializer {
  constructor() {
    CharSerializer_instance = this;
    this.g1c_1 = new PrimitiveSerialDescriptor('kotlin.Char', CHAR_getInstance());
  }
  yu() {
    return this.g1c_1;
  }
  h1c(encoder, value) {
    return encoder.b10(value);
  }
  zu(encoder, value) {
    return this.h1c(encoder, value instanceof Char ? value.n2_1 : THROW_CCE());
  }
  i1c(decoder) {
    return decoder.ry();
  }
  av(decoder) {
    return new Char(this.i1c(decoder));
  }
}
class DoubleSerializer {
  constructor() {
    DoubleSerializer_instance = this;
    this.j1c_1 = new PrimitiveSerialDescriptor('kotlin.Double', DOUBLE_getInstance());
  }
  yu() {
    return this.j1c_1;
  }
  k1c(encoder, value) {
    return encoder.a10(value);
  }
  zu(encoder, value) {
    return this.k1c(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.qy();
  }
}
class FloatSerializer {
  constructor() {
    FloatSerializer_instance = this;
    this.l1c_1 = new PrimitiveSerialDescriptor('kotlin.Float', FLOAT_getInstance());
  }
  yu() {
    return this.l1c_1;
  }
  m1c(encoder, value) {
    return encoder.zz(value);
  }
  zu(encoder, value) {
    return this.m1c(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.py();
  }
}
class LongSerializer {
  constructor() {
    LongSerializer_instance = this;
    this.n1c_1 = new PrimitiveSerialDescriptor('kotlin.Long', LONG_getInstance());
  }
  yu() {
    return this.n1c_1;
  }
  o1c(encoder, value) {
    return encoder.yz(value);
  }
  zu(encoder, value) {
    return this.o1c(encoder, value instanceof Long ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.oy();
  }
}
class IntSerializer {
  constructor() {
    IntSerializer_instance = this;
    this.p1c_1 = new PrimitiveSerialDescriptor('kotlin.Int', INT_getInstance());
  }
  yu() {
    return this.p1c_1;
  }
  q1c(encoder, value) {
    return encoder.xz(value);
  }
  zu(encoder, value) {
    return this.q1c(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.ny();
  }
}
class ShortSerializer {
  constructor() {
    ShortSerializer_instance = this;
    this.r1c_1 = new PrimitiveSerialDescriptor('kotlin.Short', SHORT_getInstance());
  }
  yu() {
    return this.r1c_1;
  }
  s1c(encoder, value) {
    return encoder.wz(value);
  }
  zu(encoder, value) {
    return this.s1c(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.my();
  }
}
class ByteSerializer {
  constructor() {
    ByteSerializer_instance = this;
    this.t1c_1 = new PrimitiveSerialDescriptor('kotlin.Byte', BYTE_getInstance());
  }
  yu() {
    return this.t1c_1;
  }
  u1c(encoder, value) {
    return encoder.vz(value);
  }
  zu(encoder, value) {
    return this.u1c(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.ly();
  }
}
class BooleanSerializer {
  constructor() {
    BooleanSerializer_instance = this;
    this.v1c_1 = new PrimitiveSerialDescriptor('kotlin.Boolean', BOOLEAN_getInstance());
  }
  yu() {
    return this.v1c_1;
  }
  w1c(encoder, value) {
    return encoder.uz(value);
  }
  zu(encoder, value) {
    return this.w1c(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  }
  av(decoder) {
    return decoder.ky();
  }
}
class UnitSerializer {
  constructor() {
    UnitSerializer_instance = this;
    this.x1c_1 = ObjectSerializer.p17('kotlin.Unit', Unit_instance);
  }
  y1c(encoder, value) {
    this.x1c_1.rv(encoder, Unit_instance);
  }
  zu(encoder, value) {
    return this.y1c(encoder, value instanceof Unit ? value : THROW_CCE());
  }
  z1c(decoder) {
    this.x1c_1.av(decoder);
  }
  av(decoder) {
    this.z1c(decoder);
    return Unit_instance;
  }
  yu() {
    return this.x1c_1.yu();
  }
}
class PrimitiveSerialDescriptor {
  constructor(serialName, kind) {
    this.a1d_1 = serialName;
    this.b1d_1 = kind;
  }
  ax() {
    return this.a1d_1;
  }
  gx() {
    return this.b1d_1;
  }
  ix() {
    return 0;
  }
  bx(index) {
    error_0(this);
  }
  cx(name) {
    error_0(this);
  }
  fx(index) {
    error_0(this);
  }
  ex(index) {
    error_0(this);
  }
  dx(index) {
    error_0(this);
  }
  toString() {
    return 'PrimitiveDescriptor(' + this.a1d_1 + ')';
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor))
      return false;
    if (this.a1d_1 === other.a1d_1 && equals(this.b1d_1, other.b1d_1))
      return true;
    return false;
  }
  hashCode() {
    return getStringHashCode(this.a1d_1) + imul(31, this.b1d_1.hashCode()) | 0;
  }
}
class TaggedDecoder {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.h1d_1 = ArrayList.z();
    this.i1d_1 = false;
  }
  mz() {
    return EmptySerializersModule_0();
  }
  m1d(tag) {
    throw SerializationException.aw(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  }
  n1d(tag) {
    return true;
  }
  o1d(tag) {
    var tmp = this.m1d(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  }
  p1d(tag) {
    var tmp = this.m1d(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  q1d(tag) {
    var tmp = this.m1d(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  r1d(tag) {
    var tmp = this.m1d(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  s1d(tag) {
    var tmp = this.m1d(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  }
  t1d(tag) {
    var tmp = this.m1d(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  u1d(tag) {
    var tmp = this.m1d(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  v1d(tag) {
    var tmp = this.m1d(tag);
    return tmp instanceof Char ? tmp.n2_1 : THROW_CCE();
  }
  w1d(tag) {
    var tmp = this.m1d(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  }
  x1d(tag, enumDescriptor) {
    var tmp = this.m1d(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  y1d(tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
    this.z1d(tag);
    return this;
  }
  vy(deserializer, previousValue) {
    return this.wy(deserializer);
  }
  uy(descriptor) {
    return this.y1d(this.a1e(), descriptor);
  }
  iy() {
    var tmp0_elvis_lhs = this.j1d();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.n1d(currentTag);
  }
  jy() {
    return null;
  }
  ky() {
    return this.o1d(this.a1e());
  }
  ly() {
    return this.p1d(this.a1e());
  }
  my() {
    return this.q1d(this.a1e());
  }
  ny() {
    return this.r1d(this.a1e());
  }
  oy() {
    return this.s1d(this.a1e());
  }
  py() {
    return this.t1d(this.a1e());
  }
  qy() {
    return this.u1d(this.a1e());
  }
  ry() {
    return this.v1d(this.a1e());
  }
  sy() {
    return this.w1d(this.a1e());
  }
  ty(enumDescriptor) {
    return this.x1d(this.a1e(), enumDescriptor);
  }
  xy(descriptor) {
    return this;
  }
  yy(descriptor) {
  }
  zy(descriptor, index) {
    return this.o1d(this.e1d(descriptor, index));
  }
  az(descriptor, index) {
    return this.p1d(this.e1d(descriptor, index));
  }
  bz(descriptor, index) {
    return this.q1d(this.e1d(descriptor, index));
  }
  cz(descriptor, index) {
    return this.r1d(this.e1d(descriptor, index));
  }
  dz(descriptor, index) {
    return this.s1d(this.e1d(descriptor, index));
  }
  ez(descriptor, index) {
    return this.t1d(this.e1d(descriptor, index));
  }
  fz(descriptor, index) {
    return this.u1d(this.e1d(descriptor, index));
  }
  gz(descriptor, index) {
    return this.v1d(this.e1d(descriptor, index));
  }
  hz(descriptor, index) {
    return this.w1d(this.e1d(descriptor, index));
  }
  iz(descriptor, index) {
    return this.y1d(this.e1d(descriptor, index), descriptor.ex(index));
  }
  jz(descriptor, index, deserializer, previousValue) {
    var tmp = this.e1d(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  }
  lz(descriptor, index, deserializer, previousValue) {
    var tmp = this.e1d(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  }
  j1d() {
    return lastOrNull(this.h1d_1);
  }
  z1d(name) {
    this.h1d_1.h(name);
  }
  a1e() {
    var r = this.h1d_1.j3(get_lastIndex_0(this.h1d_1));
    this.i1d_1 = true;
    return r;
  }
}
class NamedValueDecoder extends TaggedDecoder {
  e1d(_this__u8e3s4, index) {
    return this.g1d(this.f1d(_this__u8e3s4, index));
  }
  g1d(nestedName) {
    var tmp0_elvis_lhs = this.j1d();
    return this.k1d(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  }
  f1d(descriptor, index) {
    return descriptor.bx(index);
  }
  k1d(parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  }
  l1d() {
    return this.h1d_1.j1() ? '$' : joinToString(this.h1d_1, '.', '$.');
  }
}
class MapEntry {
  constructor(key, value) {
    this.b1e_1 = key;
    this.c1e_1 = value;
  }
  v1() {
    return this.b1e_1;
  }
  w1() {
    return this.c1e_1;
  }
  toString() {
    return 'MapEntry(key=' + toString_0(this.b1e_1) + ', value=' + toString_0(this.c1e_1) + ')';
  }
  hashCode() {
    var result = this.b1e_1 == null ? 0 : hashCode(this.b1e_1);
    result = imul(result, 31) + (this.c1e_1 == null ? 0 : hashCode(this.c1e_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.b1e_1, tmp0_other_with_cast.b1e_1))
      return false;
    if (!equals(this.c1e_1, tmp0_other_with_cast.c1e_1))
      return false;
    return true;
  }
}
class KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    this.l1e_1 = keySerializer;
    this.m1e_1 = valueSerializer;
  }
  n1e(encoder, value) {
    var structuredEncoder = encoder.xy(this.yu());
    structuredEncoder.p10(this.yu(), 0, this.l1e_1, this.h1e(value));
    structuredEncoder.p10(this.yu(), 1, this.m1e_1, this.j1e(value));
    structuredEncoder.yy(this.yu());
  }
  zu(encoder, value) {
    return this.n1e(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  av(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.yu();
    var composite = decoder.xy(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
      if (composite.nz()) {
        var key = composite.kz(this.yu(), 0, this.l1e_1);
        var value = composite.kz(this.yu(), 1, this.m1e_1);
        tmp$ret$0 = this.k1e(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.oz(this.yu());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.kz(this.yu(), 0, this.l1e_1);
            break;
          case 1:
            value_0 = composite.kz(this.yu(), 1, this.m1e_1);
            break;
          default:
            throw SerializationException.aw('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException.aw("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException.aw("Element 'value' is missing");
      var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.k1e(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.yy(descriptor);
    return result;
  }
}
class MapEntrySerializer extends KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    super(keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.f1e_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  yu() {
    return this.f1e_1;
  }
  g1e(_this__u8e3s4) {
    return _this__u8e3s4.v1();
  }
  h1e(_this__u8e3s4) {
    return this.g1e((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  i1e(_this__u8e3s4) {
    return _this__u8e3s4.w1();
  }
  j1e(_this__u8e3s4) {
    return this.i1e((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  k1e(key, value) {
    return new MapEntry(key, value);
  }
}
class PairSerializer extends KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    super(keySerializer, valueSerializer);
    var tmp = this;
    tmp.q1e_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  yu() {
    return this.q1e_1;
  }
  r1e(_this__u8e3s4) {
    return _this__u8e3s4.nm_1;
  }
  h1e(_this__u8e3s4) {
    return this.r1e(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  }
  s1e(_this__u8e3s4) {
    return _this__u8e3s4.om_1;
  }
  j1e(_this__u8e3s4) {
    return this.s1e(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  }
  k1e(key, value) {
    return to(key, value);
  }
}
class TripleSerializer {
  constructor(aSerializer, bSerializer, cSerializer) {
    this.t1e_1 = aSerializer;
    this.u1e_1 = bSerializer;
    this.v1e_1 = cSerializer;
    var tmp = this;
    tmp.w1e_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  yu() {
    return this.w1e_1;
  }
  x1e(encoder, value) {
    var structuredEncoder = encoder.xy(this.w1e_1);
    structuredEncoder.p10(this.w1e_1, 0, this.t1e_1, value.gt_1);
    structuredEncoder.p10(this.w1e_1, 1, this.u1e_1, value.ht_1);
    structuredEncoder.p10(this.w1e_1, 2, this.v1e_1, value.it_1);
    structuredEncoder.yy(this.w1e_1);
  }
  zu(encoder, value) {
    return this.x1e(encoder, value instanceof Triple ? value : THROW_CCE());
  }
  av(decoder) {
    var composite = decoder.xy(this.w1e_1);
    if (composite.nz()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  }
}
class ULongSerializer {
  constructor() {
    ULongSerializer_instance = this;
    this.y1e_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_5(Companion_getInstance_1()));
  }
  yu() {
    return this.y1e_1;
  }
  z1e(encoder, value) {
    var tmp = encoder.e10(this.y1e_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.yz(tmp$ret$0);
  }
  zu(encoder, value) {
    return this.z1e(encoder, value instanceof ULong ? value.iu_1 : THROW_CCE());
  }
  a1f(decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.uy(this.y1e_1).oy();
    return _ULong___init__impl__c78o9k(this_0);
  }
  av(decoder) {
    return new ULong(this.a1f(decoder));
  }
}
class UIntSerializer {
  constructor() {
    UIntSerializer_instance = this;
    this.b1f_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_7(IntCompanionObject_instance));
  }
  yu() {
    return this.b1f_1;
  }
  c1f(encoder, value) {
    var tmp = encoder.e10(this.b1f_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.xz(tmp$ret$0);
  }
  zu(encoder, value) {
    return this.c1f(encoder, value instanceof UInt ? value.yt_1 : THROW_CCE());
  }
  d1f(decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.uy(this.b1f_1).ny();
    return _UInt___init__impl__l7qpdl(this_0);
  }
  av(decoder) {
    return new UInt(this.d1f(decoder));
  }
}
class UShortSerializer {
  constructor() {
    UShortSerializer_instance = this;
    this.e1f_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_9(ShortCompanionObject_instance));
  }
  yu() {
    return this.e1f_1;
  }
  f1f(encoder, value) {
    var tmp = encoder.e10(this.e1f_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.wz(tmp$ret$0);
  }
  zu(encoder, value) {
    return this.f1f(encoder, value instanceof UShort ? value.su_1 : THROW_CCE());
  }
  g1f(decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.uy(this.e1f_1).my();
    return _UShort___init__impl__jigrne(this_0);
  }
  av(decoder) {
    return new UShort(this.g1f(decoder));
  }
}
class UByteSerializer {
  constructor() {
    UByteSerializer_instance = this;
    this.h1f_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_11(ByteCompanionObject_instance));
  }
  yu() {
    return this.h1f_1;
  }
  i1f(encoder, value) {
    var tmp = encoder.e10(this.h1f_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.vz(tmp$ret$0);
  }
  zu(encoder, value) {
    return this.i1f(encoder, value instanceof UByte ? value.ot_1 : THROW_CCE());
  }
  j1f(decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.uy(this.h1f_1).ly();
    return _UByte___init__impl__g9hnc4(this_0);
  }
  av(decoder) {
    return new UByte(this.j1f(decoder));
  }
}
class PolymorphicModuleBuilder {
  constructor(baseClass, baseSerializer) {
    baseSerializer = baseSerializer === VOID ? null : baseSerializer;
    this.k1f_1 = baseClass;
    this.l1f_1 = baseSerializer;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.m1f_1 = ArrayList.z();
    this.n1f_1 = null;
    this.o1f_1 = null;
  }
  p1f(subclass, serializer) {
    this.m1f_1.h(to(subclass, serializer));
  }
  q1f(builder) {
    if (!(this.l1f_1 == null)) {
      builder.x1f(this.k1f_1, this.k1f_1, this.l1f_1);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.m1f_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlinx.serialization.modules.PolymorphicModuleBuilder.buildTo.<anonymous>' call
      var kclass = element.em();
      var serializer = element.fm();
      var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var tmp$ret$0 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
      builder.x1f(this.k1f_1, tmp, tmp$ret$0);
    }
    var defaultSerializer = this.n1f_1;
    if (!(defaultSerializer == null)) {
      builder.y1f(this.k1f_1, defaultSerializer, false);
    }
    var defaultDeserializer = this.o1f_1;
    if (!(defaultDeserializer == null)) {
      builder.z1f(this.k1f_1, defaultDeserializer, false);
    }
  }
}
class SerializersModule {
  sw(kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.tw(kClass, typeArgumentsSerializers) : $super.tw.call(this, kClass, typeArgumentsSerializers);
  }
}
class SerialModuleImpl extends SerializersModule {
  constructor(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
    super();
    this.b1g_1 = class2ContextualFactory;
    this.c1g_1 = polyBase2Serializers;
    this.d1g_1 = polyBase2DefaultSerializerProvider;
    this.e1g_1 = polyBase2NamedSerializers;
    this.f1g_1 = polyBase2DefaultDeserializerProvider;
    this.g1g_1 = hasInterfaceContextualSerializers;
  }
  rw() {
    return this.g1g_1;
  }
  x10(baseClass, value) {
    if (!baseClass.zf(value))
      return null;
    var tmp28_safe_receiver = this.c1g_1.e3(baseClass);
    var tmp = tmp28_safe_receiver == null ? null : tmp28_safe_receiver.e3(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.d1g_1.e3(baseClass);
    var tmp29_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp29_safe_receiver == null ? null : tmp29_safe_receiver(value);
  }
  w10(baseClass, serializedClassName) {
    var tmp30_safe_receiver = this.e1g_1.e3(baseClass);
    var tmp;
    if (tmp30_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp30_safe_receiver, KtMap) ? tmp30_safe_receiver : THROW_CCE()).e3(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.f1g_1.e3(baseClass);
    var tmp31_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp31_safe_receiver == null ? null : tmp31_safe_receiver(serializedClassName);
  }
  tw(kClass, typeArgumentsSerializers) {
    var tmp32_safe_receiver = this.b1g_1.e3(kClass);
    var tmp = tmp32_safe_receiver == null ? null : tmp32_safe_receiver.h1g(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  }
  a1g(collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.b1g_1.u1().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.v1();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.w1();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.k1g_1;
        collector.l1g(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.j1g(kclass, serial.i1g_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = this.c1g_1.u1().b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.v1();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.w1();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = classMap.u1().b1();
      while (tmp0_iterator_1.c1()) {
        var element_1 = tmp0_iterator_1.d1();
        // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.v1();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.w1();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$9 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.m1g(tmp_1, tmp_2, tmp$ret$9);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_2 = this.d1g_1.u1().b1();
    while (tmp0_iterator_2.c1()) {
      var element_2 = tmp0_iterator_2.d1();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.v1();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.w1();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.n1g(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_3 = this.f1g_1.u1().b1();
    while (tmp0_iterator_3.c1()) {
      var element_3 = tmp0_iterator_3.d1();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.v1();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.w1();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.o1g(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  }
}
class ContextualProvider {}
class Argless extends ContextualProvider {
  constructor(serializer) {
    super();
    this.k1g_1 = serializer;
  }
  h1g(typeArgumentsSerializers) {
    return this.k1g_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Argless) {
      tmp = equals(other.k1g_1, this.k1g_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k1g_1);
  }
}
class WithTypeArguments extends ContextualProvider {
  constructor(provider) {
    super();
    this.i1g_1 = provider;
  }
  h1g(typeArgumentsSerializers) {
    return this.i1g_1(typeArgumentsSerializers);
  }
}
class SerializersModuleCollector {}
function contextual(kClass, serializer) {
  return this.j1g(kClass, SerializersModuleCollector$contextual$lambda(serializer));
}
class SerializersModuleBuilder {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.r1f_1 = HashMap.a9();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.s1f_1 = HashMap.a9();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.t1f_1 = HashMap.a9();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_2.u1f_1 = HashMap.a9();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_3.v1f_1 = HashMap.a9();
    this.w1f_1 = false;
  }
  l1g(kClass, serializer) {
    return this.q1g(kClass, new Argless(serializer));
  }
  j1g(kClass, provider) {
    return this.q1g(kClass, new WithTypeArguments(provider));
  }
  m1g(baseClass, actualClass, actualSerializer) {
    this.x1f(baseClass, actualClass, actualSerializer);
  }
  n1g(baseClass, defaultSerializerProvider) {
    this.y1f(baseClass, defaultSerializerProvider, false);
  }
  o1g(baseClass, defaultDeserializerProvider) {
    this.z1f(baseClass, defaultDeserializerProvider, false);
  }
  p1g(module_0) {
    module_0.a1g(this);
  }
  r1g(forClass, provider, allowOverwrite) {
    if (!allowOverwrite) {
      var previous = this.r1f_1.e3(forClass);
      if (!(previous == null) && !equals(previous, provider)) {
        throw SerializerAlreadyRegisteredException.w1g('Contextual serializer or serializer provider for ' + toString(forClass) + ' already registered in this module');
      }
    }
    // Inline function 'kotlin.collections.set' call
    this.r1f_1.k3(forClass, provider);
    if (isInterface_0(forClass))
      this.w1f_1 = true;
  }
  q1g(forClass, provider, allowOverwrite, $super) {
    allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
    var tmp;
    if ($super === VOID) {
      this.r1g(forClass, provider, allowOverwrite);
      tmp = Unit_instance;
    } else {
      tmp = $super.r1g.call(this, forClass, provider, allowOverwrite);
    }
    return tmp;
  }
  y1f(baseClass, defaultSerializerProvider, allowOverwrite) {
    var previous = this.t1f_1.e3(baseClass);
    if (!(previous == null) && !equals(previous, defaultSerializerProvider) && !allowOverwrite) {
      throw IllegalArgumentException.l('Default serializers provider for ' + toString(baseClass) + ' is already registered: ' + toString_0(previous));
    }
    // Inline function 'kotlin.collections.set' call
    this.t1f_1.k3(baseClass, defaultSerializerProvider);
  }
  z1f(baseClass, defaultDeserializerProvider, allowOverwrite) {
    var previous = this.v1f_1.e3(baseClass);
    if (!(previous == null) && !equals(previous, defaultDeserializerProvider) && !allowOverwrite) {
      throw IllegalArgumentException.l('Default deserializers provider for ' + toString(baseClass) + ' is already registered: ' + toString_0(previous));
    }
    // Inline function 'kotlin.collections.set' call
    this.v1f_1.k3(baseClass, defaultDeserializerProvider);
  }
  x1g(baseClass, concreteClass, concreteSerializer, allowOverwrite) {
    var name = concreteSerializer.yu().ax();
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.s1f_1;
    var value = this_0.e3(baseClass);
    var tmp;
    if (value == null) {
      // Inline function 'kotlin.collections.hashMapOf' call
      // Inline function 'kotlin.collections.hashMapOf' call
      var answer = HashMap.a9();
      this_0.k3(baseClass, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var baseClassSerializers = tmp;
    var previousSerializer = baseClassSerializers.e3(concreteClass);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_1 = this.u1f_1;
    var value_0 = this_1.e3(baseClass);
    var tmp_0;
    if (value_0 == null) {
      // Inline function 'kotlin.collections.hashMapOf' call
      // Inline function 'kotlin.collections.hashMapOf' call
      var answer_0 = HashMap.a9();
      this_1.k3(baseClass, answer_0);
      tmp_0 = answer_0;
    } else {
      tmp_0 = value_0;
    }
    var names = tmp_0;
    if (allowOverwrite) {
      if (!(previousSerializer == null)) {
        names.l3(previousSerializer.yu().ax());
      }
      // Inline function 'kotlin.collections.set' call
      baseClassSerializers.k3(concreteClass, concreteSerializer);
      // Inline function 'kotlin.collections.set' call
      names.k3(name, concreteSerializer);
      return Unit_instance;
    }
    if (!(previousSerializer == null)) {
      if (!equals(previousSerializer, concreteSerializer)) {
        throw SerializerAlreadyRegisteredException.y1g(baseClass, concreteClass);
      } else {
        names.l3(previousSerializer.yu().ax());
      }
    }
    var previousByName = names.e3(name);
    if (!(previousByName == null)) {
      // Inline function 'kotlin.sequences.find' call
      var this_2 = asSequence(ensureNotNull(this.s1f_1.e3(baseClass)));
      var tmp$ret$7;
      $l$block: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var tmp0_iterator = this_2.b1();
        while (tmp0_iterator.c1()) {
          var element = tmp0_iterator.d1();
          // Inline function 'kotlinx.serialization.modules.SerializersModuleBuilder.registerPolymorphicSerializer.<anonymous>' call
          if (element.w1() === previousByName) {
            tmp$ret$7 = element;
            break $l$block;
          }
        }
        tmp$ret$7 = null;
      }
      var conflictingClass = tmp$ret$7;
      throw IllegalArgumentException.l("Multiple polymorphic serializers for base class '" + toString(baseClass) + "' " + ("have the same serial name '" + name + "': '" + toString(concreteClass) + "' and '" + toString_0(conflictingClass) + "'"));
    }
    // Inline function 'kotlin.collections.set' call
    baseClassSerializers.k3(concreteClass, concreteSerializer);
    // Inline function 'kotlin.collections.set' call
    names.k3(name, concreteSerializer);
  }
  x1f(baseClass, concreteClass, concreteSerializer, allowOverwrite, $super) {
    allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
    var tmp;
    if ($super === VOID) {
      this.x1g(baseClass, concreteClass, concreteSerializer, allowOverwrite);
      tmp = Unit_instance;
    } else {
      tmp = $super.x1g.call(this, baseClass, concreteClass, concreteSerializer, allowOverwrite);
    }
    return tmp;
  }
  n14() {
    return new SerialModuleImpl(this.r1f_1, this.s1f_1, this.t1f_1, this.u1f_1, this.v1f_1, this.w1f_1);
  }
}
class SerializerAlreadyRegisteredException extends IllegalArgumentException {
  static w1g(msg) {
    var $this = this.l(msg);
    captureStack($this, $this.v1g_1);
    return $this;
  }
  static y1g(baseClass, concreteClass) {
    return this.w1g('Serializer for ' + toString(concreteClass) + ' already registered in the scope of ' + toString(baseClass));
  }
}
class SerializableWith {
  constructor(serializer) {
    this.z1g_1 = serializer;
  }
  equals(other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.z1g_1.equals(tmp0_other_with_cast.z1g_1))
      return false;
    return true;
  }
  hashCode() {
    return imul(getStringHashCode('serializer'), 127) ^ this.z1g_1.hashCode();
  }
  toString() {
    return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.z1g_1) + ')';
  }
}
class createCache$1 {
  constructor($factory) {
    this.a1h_1 = $factory;
  }
  uw(key) {
    return this.a1h_1(key);
  }
}
class createParametrizedCache$1 {
  constructor($factory) {
    this.b1h_1 = $factory;
  }
  vw(key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
      var value = this.b1h_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
}
//endregion
function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.jv('type', serializer_1(StringCompanionObject_instance).yu());
    $this$buildSerialDescriptor.jv('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.kv_1.yf() + '>', CONTEXTUAL_getInstance(), []));
    $this$buildSerialDescriptor.dv_1 = this$0.lv_1;
    return Unit_instance;
  };
}
function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
  return function () {
    var tmp = OPEN_getInstance();
    return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.kv_1);
  };
}
function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.tv(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.pv());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.sv(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.pv());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function descriptor$factory() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.yu();
  }, null);
}
function descriptor$factory_0() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.yu();
  }, null);
}
function init_kotlinx_serialization_SerializationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.yv_1);
}
function serializerOrNull(_this__u8e3s4) {
  var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
}
function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
  var tmp;
  if (failOnMissingTypeArgSerializer) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(typeArguments, 10));
    var tmp0_iterator = typeArguments.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
      var tmp$ret$0 = serializer(_this__u8e3s4, item);
      destination.h(tmp$ret$0);
    }
    tmp = destination;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(typeArguments, 10));
    var tmp0_iterator_0 = typeArguments.b1();
    while (tmp0_iterator_0.c1()) {
      var item_0 = tmp0_iterator_0.d1();
      // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
      var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$3 = tmp_0;
      destination_0.h(tmp$ret$3);
    }
    tmp = destination_0;
  }
  var serializers = tmp;
  return serializers;
}
function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
  return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
}
function serializer(_this__u8e3s4, type) {
  var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    platformSpecificSerializerNotRegistered(kclass(type));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function serializerOrNull_0(_this__u8e3s4, type) {
  return serializerByKTypeImpl(_this__u8e3s4, type, false);
}
function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp;
  if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
    tmp = new ArrayListSerializer(serializers.h1(0));
  } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
    tmp = new HashSetSerializer(serializers.h1(0));
  } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
    tmp = new LinkedHashSetSerializer(serializers.h1(0));
  } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
    tmp = new HashMapSerializer(serializers.h1(0), serializers.h1(1));
  } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
    tmp = new LinkedHashMapSerializer(serializers.h1(0), serializers.h1(1));
  } else if (_this__u8e3s4.equals(getKClass(Entry))) {
    tmp = MapEntrySerializer_0(serializers.h1(0), serializers.h1(1));
  } else if (_this__u8e3s4.equals(getKClass(Pair))) {
    tmp = PairSerializer_0(serializers.h1(0), serializers.h1(1));
  } else if (_this__u8e3s4.equals(getKClass(Triple))) {
    tmp = TripleSerializer_0(serializers.h1(0), serializers.h1(1), serializers.h1(2));
  } else {
    var tmp_0;
    if (isReferenceArray(_this__u8e3s4)) {
      var tmp_1 = elementClassifierIfArray();
      tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.h1(0));
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(serializers);
  return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
}
function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
  var rootClass = kclass(type);
  var isNullable = type.og();
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.ng();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    var tmp$ret$0 = typeOrThrow(item);
    destination.h(tmp$ret$0);
  }
  var typeArguments = destination;
  var tmp;
  if (typeArguments.j1()) {
    var tmp_0;
    if (isInterface_0(rootClass) && !(_this__u8e3s4.sw(rootClass) == null)) {
      tmp_0 = null;
    } else {
      tmp_0 = findCachedSerializer(rootClass, isNullable);
    }
    tmp = tmp_0;
  } else {
    var tmp_1;
    if (_this__u8e3s4.rw()) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_2;
      if (_Result___get_isFailure__impl__jpiriv(this_1)) {
        tmp_2 = null;
      } else {
        var tmp_3 = _Result___get_value__impl__bjfvqg(this_1);
        tmp_2 = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
      }
      tmp_1 = tmp_2;
    }
    tmp = tmp_1;
  }
  var cachedSerializer = tmp;
  if (!(cachedSerializer == null))
    return cachedSerializer;
  var tmp_4;
  if (typeArguments.j1()) {
    var tmp0_elvis_lhs = serializerOrNull(rootClass);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.sw(rootClass) : tmp0_elvis_lhs;
    var tmp_5;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_5 = isInterface_0(rootClass) ? PolymorphicSerializer.nv(rootClass) : null;
    } else {
      tmp_5 = tmp1_elvis_lhs;
    }
    tmp_4 = tmp_5;
  } else {
    var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
    var tmp_6;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_6 = tmp2_elvis_lhs;
    }
    var serializers = tmp_6;
    var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
    var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.tw(rootClass, serializers) : tmp3_elvis_lhs;
    var tmp_7;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_7 = isInterface_0(rootClass) ? PolymorphicSerializer.nv(rootClass) : null;
    } else {
      tmp_7 = tmp4_elvis_lhs;
    }
    tmp_4 = tmp_7;
  }
  var contextualSerializer = tmp_4;
  var tmp_8;
  if (contextualSerializer == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_8 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
  }
  var tmp4_safe_receiver = tmp_8;
  return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
}
function nullable(_this__u8e3s4, shouldBeNullable) {
  if (shouldBeNullable)
    return get_nullable(_this__u8e3s4);
  return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
}
function serializer_0(type) {
  return serializer(EmptySerializersModule_0(), type);
}
function serializerByKTypeImpl$lambda($typeArguments) {
  return function () {
    return $typeArguments.h1(0).mg();
  };
}
function get_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE;
}
var SERIALIZERS_CACHE;
function get_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE_NULLABLE;
}
var SERIALIZERS_CACHE_NULLABLE;
function get_PARAMETRIZED_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE;
}
var PARAMETRIZED_SERIALIZERS_CACHE;
function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
}
var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
function findCachedSerializer(clazz, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp12_safe_receiver = get_SERIALIZERS_CACHE().uw(clazz);
    var tmp_0;
    if (tmp12_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp12_safe_receiver, KSerializer) ? tmp12_safe_receiver : THROW_CCE();
    }
    tmp = tmp_0;
  } else {
    tmp = get_SERIALIZERS_CACHE_NULLABLE().uw(clazz);
  }
  return tmp;
}
function findParametrizedCachedSerializer(clazz, types, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().vw(clazz, types);
    tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
  } else {
    tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().vw(clazz, types);
  }
  return tmp;
}
function SERIALIZERS_CACHE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? PolymorphicSerializer.nv(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? PolymorphicSerializer.nv(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp8_safe_receiver = tmp;
  var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : get_nullable(tmp8_safe_receiver);
  var tmp_0;
  if (tmp9_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_0 = isInterface(tmp9_safe_receiver, KSerializer) ? tmp9_safe_receiver : THROW_CCE();
  }
  return tmp_0;
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
  return function () {
    return $types.h1(0).mg();
  };
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  var tmp10_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
  var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : get_nullable(tmp10_safe_receiver);
  var tmp;
  if (tmp11_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp = isInterface(tmp11_safe_receiver, KSerializer) ? tmp11_safe_receiver : THROW_CCE();
  }
  return tmp;
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
  return function () {
    return $types.h1(0).mg();
  };
}
var properties_initialized_SerializersCache_kt_q8kf25;
function _init_properties_SerializersCache_kt__hgwi2p() {
  if (!properties_initialized_SerializersCache_kt_q8kf25) {
    properties_initialized_SerializersCache_kt_q8kf25 = true;
    SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
    SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
  }
}
function get_nullable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.yu().ww()) {
    tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  } else {
    tmp = new NullableSerializer(_this__u8e3s4);
  }
  return tmp;
}
function serializer_1(_this__u8e3s4) {
  return StringSerializer_getInstance();
}
function serializer_2(_this__u8e3s4) {
  return CharSerializer_getInstance();
}
function CharArraySerializer_0() {
  return CharArraySerializer_getInstance();
}
function serializer_3(_this__u8e3s4) {
  return DoubleSerializer_getInstance();
}
function DoubleArraySerializer_0() {
  return DoubleArraySerializer_getInstance();
}
function serializer_4(_this__u8e3s4) {
  return FloatSerializer_getInstance();
}
function FloatArraySerializer_0() {
  return FloatArraySerializer_getInstance();
}
function serializer_5(_this__u8e3s4) {
  return LongSerializer_getInstance();
}
function LongArraySerializer_0() {
  return LongArraySerializer_getInstance();
}
function serializer_6(_this__u8e3s4) {
  return ULongSerializer_getInstance();
}
function ULongArraySerializer_0() {
  return ULongArraySerializer_getInstance();
}
function serializer_7(_this__u8e3s4) {
  return IntSerializer_getInstance();
}
function IntArraySerializer_0() {
  return IntArraySerializer_getInstance();
}
function serializer_8(_this__u8e3s4) {
  return UIntSerializer_getInstance();
}
function UIntArraySerializer_0() {
  return UIntArraySerializer_getInstance();
}
function serializer_9(_this__u8e3s4) {
  return ShortSerializer_getInstance();
}
function ShortArraySerializer_0() {
  return ShortArraySerializer_getInstance();
}
function serializer_10(_this__u8e3s4) {
  return UShortSerializer_getInstance();
}
function UShortArraySerializer_0() {
  return UShortArraySerializer_getInstance();
}
function serializer_11(_this__u8e3s4) {
  return ByteSerializer_getInstance();
}
function ByteArraySerializer_0() {
  return ByteArraySerializer_getInstance();
}
function serializer_12(_this__u8e3s4) {
  return UByteSerializer_getInstance();
}
function UByteArraySerializer_0() {
  return UByteArraySerializer_getInstance();
}
function serializer_13(_this__u8e3s4) {
  return BooleanSerializer_getInstance();
}
function BooleanArraySerializer_0() {
  return BooleanArraySerializer_getInstance();
}
function serializer_14(_this__u8e3s4) {
  return UnitSerializer_getInstance();
}
function NothingSerializer_0() {
  return NothingSerializer_getInstance();
}
function serializer_15(_this__u8e3s4) {
  return DurationSerializer_getInstance();
}
function MapEntrySerializer_0(keySerializer, valueSerializer) {
  return new MapEntrySerializer(keySerializer, valueSerializer);
}
function PairSerializer_0(keySerializer, valueSerializer) {
  return new PairSerializer(keySerializer, valueSerializer);
}
function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
  return new TripleSerializer(aSerializer, bSerializer, cSerializer);
}
function ArraySerializer(kClass, elementSerializer) {
  return new ReferenceArraySerializer(kClass, elementSerializer);
}
function ListSerializer(elementSerializer) {
  return new ArrayListSerializer(elementSerializer);
}
function MapSerializer(keySerializer, valueSerializer) {
  return new LinkedHashMapSerializer(keySerializer, valueSerializer);
}
function withContext(_this__u8e3s4, context) {
  return new ContextDescriptor(_this__u8e3s4, context);
}
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp14_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp14_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
    var tmp15_safe_receiver = _this__u8e3s4.sw(tmp14_safe_receiver);
    tmp = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.yu();
  }
  return tmp;
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor) {
    tmp = _this__u8e3s4.yw_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
      tmp = get_capturedKClass(_this__u8e3s4.kx_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function get_elementDescriptors(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new _no_name_provided__qut3iv(_this__u8e3s4);
}
function get_elementNames(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new _no_name_provided__qut3iv_0(_this__u8e3s4);
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!isBlank(serialName)) {
    // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.l(toString(message));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!equals(kind, CLASS_getInstance())) {
    // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException.l(toString(message_0));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builder(sdBuilder);
  return new SerialDescriptorImpl(serialName, kind, sdBuilder.ev_1.g1(), toList(typeParameters), sdBuilder);
}
function _get__hashCode__tgwhef($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.fy_1;
  _hashCode$factory();
  return this_0.w1();
}
function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.ey_1);
  };
}
function SerialDescriptorImpl$toString$lambda(this$0) {
  return function (it) {
    return this$0.bx(it) + ': ' + this$0.ex(it).ax();
  };
}
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!isBlank(serialName)) {
    // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.l(toString(message));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builderAction(sdBuilder);
  return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.ev_1.g1(), toList(typeParameters), sdBuilder);
}
function PrimitiveSerialDescriptor_0(serialName, kind) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!isBlank(serialName)) {
    // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.l(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function _hashCode$factory() {
  return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
    return _get__hashCode__tgwhef(receiver);
  }, null);
}
var ENUM_instance;
function ENUM_getInstance() {
  if (ENUM_instance === VOID)
    new ENUM();
  return ENUM_instance;
}
var CONTEXTUAL_instance;
function CONTEXTUAL_getInstance() {
  if (CONTEXTUAL_instance === VOID)
    new CONTEXTUAL();
  return CONTEXTUAL_instance;
}
var SEALED_instance;
function SEALED_getInstance() {
  if (SEALED_instance === VOID)
    new SEALED();
  return SEALED_instance;
}
var OPEN_instance;
function OPEN_getInstance() {
  if (OPEN_instance === VOID)
    new OPEN();
  return OPEN_instance;
}
var BOOLEAN_instance;
function BOOLEAN_getInstance() {
  if (BOOLEAN_instance === VOID)
    new BOOLEAN();
  return BOOLEAN_instance;
}
var BYTE_instance;
function BYTE_getInstance() {
  if (BYTE_instance === VOID)
    new BYTE();
  return BYTE_instance;
}
var CHAR_instance;
function CHAR_getInstance() {
  if (CHAR_instance === VOID)
    new CHAR();
  return CHAR_instance;
}
var SHORT_instance;
function SHORT_getInstance() {
  if (SHORT_instance === VOID)
    new SHORT();
  return SHORT_instance;
}
var INT_instance;
function INT_getInstance() {
  if (INT_instance === VOID)
    new INT();
  return INT_instance;
}
var LONG_instance;
function LONG_getInstance() {
  if (LONG_instance === VOID)
    new LONG();
  return LONG_instance;
}
var FLOAT_instance;
function FLOAT_getInstance() {
  if (FLOAT_instance === VOID)
    new FLOAT();
  return FLOAT_instance;
}
var DOUBLE_instance;
function DOUBLE_getInstance() {
  if (DOUBLE_instance === VOID)
    new DOUBLE();
  return DOUBLE_instance;
}
var STRING_instance;
function STRING_getInstance() {
  if (STRING_instance === VOID)
    new STRING();
  return STRING_instance;
}
var CLASS_instance;
function CLASS_getInstance() {
  if (CLASS_instance === VOID)
    new CLASS();
  return CLASS_instance;
}
var LIST_instance;
function LIST_getInstance() {
  if (LIST_instance === VOID)
    new LIST();
  return LIST_instance;
}
var MAP_instance;
function MAP_getInstance() {
  if (MAP_instance === VOID)
    new MAP();
  return MAP_instance;
}
var OBJECT_instance;
function OBJECT_getInstance() {
  if (OBJECT_instance === VOID)
    new OBJECT();
  return OBJECT_instance;
}
function decodeSequentially_0($this, compositeDecoder) {
  var klassName = compositeDecoder.hz($this.yu(), 0);
  var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
  return compositeDecoder.kz($this.yu(), 1, serializer);
}
function throwSubtypeNotRegistered(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.yf();
  throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
function throwSubtypeNotRegistered_0(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.yf() + "'";
  throw SerializationException.aw(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.yf() + "' has to be sealed and '@Serializable'."));
}
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance === VOID)
    new NothingSerializer();
  return NothingSerializer_instance;
}
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance === VOID)
    new DurationSerializer();
  return DurationSerializer_instance;
}
function readSize($this, decoder, builder) {
  var size = decoder.pz($this.yu());
  $this.e12(builder, size);
  return size;
}
var Companion_instance_0;
function Companion_getInstance_6() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function prepareHighMarksArray($this, elementsCount) {
  var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
  var elementsInLastSlot = elementsCount & 63;
  var highMarks = longArray(slotsCount);
  if (!(elementsInLastSlot === 0)) {
    highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).e4(elementsCount);
  }
  return highMarks;
}
function markHigh($this, index) {
  var slot = (index >>> 6 | 0) - 1 | 0;
  var offsetInSlot = index & 63;
  $this.b15_1[slot] = $this.b15_1[slot].i4((new Long(1, 0)).e4(offsetInSlot));
}
function nextUnmarkedHighIndex($this) {
  var inductionVariable = 0;
  var last = $this.b15_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var slot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var slotOffset = imul(slot + 1 | 0, 64);
      var slotMarks = $this.b15_1[slot];
      while (!slotMarks.equals(new Long(-1, -1))) {
        var indexInSlot = countTrailingZeroBits(slotMarks.d4());
        slotMarks = slotMarks.i4((new Long(1, 0)).e4(indexInSlot));
        var index = slotOffset + indexInSlot | 0;
        if ($this.z14_1($this.y14_1, index)) {
          $this.b15_1[slot] = slotMarks;
          return index;
        }
      }
      $this.b15_1[slot] = slotMarks;
    }
     while (inductionVariable <= last);
  return -1;
}
function createSimpleEnumSerializer(serialName, values) {
  return EnumSerializer.h15(serialName, values);
}
function createUnmarkedDescriptor($this, serialName) {
  var d = new EnumDescriptor(serialName, $this.e15_1.length);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.e15_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlinx.serialization.internal.EnumSerializer.createUnmarkedDescriptor.<anonymous>' call
    d.u15(element.o3_1);
  }
  return d;
}
function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
  return function () {
    var tmp0_elvis_lhs = this$0.f15_1;
    return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
  };
}
function _get_elementDescriptors__y23q9p($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.k16_1;
  elementDescriptors$factory();
  return this_0.w1();
}
function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
  return function () {
    var tmp = 0;
    var tmp_0 = $elementsCount;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.bx(tmp_2), OBJECT_getInstance(), []);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function createAnnotatedEnumSerializer(serialName, values, names, entryAnnotations, classAnnotations) {
  var descriptor = new EnumDescriptor(serialName, values.length);
  if (classAnnotations == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = classAnnotations.length;
    while (inductionVariable < last) {
      var element = classAnnotations[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.serialization.internal.createAnnotatedEnumSerializer.<anonymous>' call
      descriptor.o16(element);
    }
  }
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var inductionVariable_0 = 0;
  var last_0 = values.length;
  while (inductionVariable_0 < last_0) {
    var item = values[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'kotlinx.serialization.internal.createAnnotatedEnumSerializer.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var tmp0_elvis_lhs = getOrNull(names, tmp1);
    var elementName = tmp0_elvis_lhs == null ? item.o3_1 : tmp0_elvis_lhs;
    descriptor.u15(elementName);
    var tmp22_safe_receiver = getOrNull(entryAnnotations, tmp1);
    if (tmp22_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp22_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_0 = tmp22_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'kotlinx.serialization.internal.createAnnotatedEnumSerializer.<anonymous>.<anonymous>' call
        descriptor.n16(element_0);
      }
    }
  }
  return EnumSerializer.v15(serialName, values, descriptor);
}
function descriptor$factory_1() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.yu();
  }, null);
}
function elementDescriptors$factory() {
  return getPropertyCallableRef('elementDescriptors', 1, KProperty1, function (receiver) {
    return _get_elementDescriptors__y23q9p(receiver);
  }, null);
}
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
}
function jsonCachedSerialNames(_this__u8e3s4) {
  return cachedSerialNames(_this__u8e3s4);
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder.g17();
  return NoOpEncoder_instance;
}
function error($this) {
  throw IllegalStateException.h5('Descriptor for type `kotlin.Nothing` does not have elements');
}
var NothingSerialDescriptor_instance;
function NothingSerialDescriptor_getInstance() {
  if (NothingSerialDescriptor_instance === VOID)
    new NothingSerialDescriptor();
  return NothingSerialDescriptor_instance;
}
function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.dv_1 = this$0.n17_1;
    return Unit_instance;
  };
}
function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return function () {
    var tmp = OBJECT_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function descriptor$factory_2() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.yu();
  }, null);
}
function get_EMPTY_DESCRIPTOR_ARRAY() {
  _init_properties_Platform_common_kt__3qzecs();
  return EMPTY_DESCRIPTOR_ARRAY;
}
var EMPTY_DESCRIPTOR_ARRAY;
function cachedSerialNames(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  if (isInterface(_this__u8e3s4, CachedNames))
    return _this__u8e3s4.gy();
  var result = HashSet.f1(_this__u8e3s4.ix());
  var inductionVariable = 0;
  var last = _this__u8e3s4.ix();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = _this__u8e3s4.bx(i);
      result.h(element);
    }
     while (inductionVariable < last);
  return result;
}
function kclass(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var t = _this__u8e3s4.mg();
  var tmp;
  if (!(t == null) ? isInterface(t, KClass) : false) {
    tmp = t;
  } else {
    if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
      throw IllegalArgumentException.l('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
    } else {
      throw IllegalArgumentException.l('Only KClass supported as classifier, got ' + toString_0(t));
    }
  }
  var tmp_0 = tmp;
  return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
}
function typeOrThrow(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    var value = _this__u8e3s4.cr_1;
    // Inline function 'kotlin.contracts.contract' call
    if (value == null) {
      // Inline function 'kotlinx.serialization.internal.typeOrThrow.<anonymous>' call
      var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.cr_1);
      throw IllegalArgumentException.l(toString(message));
    } else {
      tmp$ret$1 = value;
      break $l$block;
    }
  }
  return tmp$ret$1;
}
function notRegisteredMessage(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0_elvis_lhs = _this__u8e3s4.yf();
  return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
}
function compactArray(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  // Inline function 'kotlin.takeUnless' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(_this__u8e3s4 == null || _this__u8e3s4.j1())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = null;
  }
  var tmp24_safe_receiver = tmp;
  var tmp_0;
  if (tmp24_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp24_safe_receiver);
  }
  var tmp0_elvis_lhs = tmp_0;
  return tmp0_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp0_elvis_lhs;
}
function notRegisteredMessage_0(className) {
  _init_properties_Platform_common_kt__3qzecs();
  return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
}
var properties_initialized_Platform_common_kt_i7q4ty;
function _init_properties_Platform_common_kt__3qzecs() {
  if (!properties_initialized_Platform_common_kt_i7q4ty) {
    properties_initialized_Platform_common_kt_i7q4ty = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_DESCRIPTOR_ARRAY = [];
  }
}
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList.z();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.bx(i);
        missingFields.h(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException.qw(missingFields, descriptor.ax());
}
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.ax());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var tmp0_iterator = elementDescriptors.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
    var tmp0_safe_receiver = element.ax();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var tmp0_iterator_0 = elementDescriptors.b1();
  while (tmp0_iterator_0.c1()) {
    var element_0 = tmp0_iterator_0.d1();
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
    var tmp0_safe_receiver_0 = element_0.gx();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
function _get_childSerializers__7vnyfa($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.r15_1;
  childSerializers$factory();
  return this_0.w1();
}
function _get__hashCode__tgwhef_0($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.t15_1;
  _hashCode$factory_0();
  return this_0.w1();
}
function buildIndices($this) {
  var indices = HashMap.a9();
  var inductionVariable = 0;
  var last = $this.m15_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.m15_1[i];
      indices.k3(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
  return function () {
    var tmp25_safe_receiver = this$0.j15_1;
    var tmp0_elvis_lhs = tmp25_safe_receiver == null ? null : tmp25_safe_receiver.d17();
    return tmp0_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp0_elvis_lhs;
  };
}
function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
  return function () {
    var tmp26_safe_receiver = this$0.j15_1;
    var tmp27_safe_receiver = tmp26_safe_receiver == null ? null : tmp26_safe_receiver.e17();
    var tmp;
    if (tmp27_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(tmp27_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp27_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp27_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.yu();
        destination.h(tmp$ret$0);
      }
      tmp = destination;
    }
    return compactArray(tmp);
  };
}
function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.l16());
  };
}
function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
  return function (i) {
    return this$0.bx(i) + ': ' + this$0.ex(i).ax();
  };
}
function childSerializers$factory() {
  return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
    return _get_childSerializers__7vnyfa(receiver);
  }, null);
}
function typeParameterDescriptors$factory() {
  return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
    return receiver.l16();
  }, null);
}
function _hashCode$factory_0() {
  return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
    return _get__hashCode__tgwhef_0(receiver);
  }, null);
}
function get_EMPTY_SERIALIZER_ARRAY() {
  _init_properties_PluginHelperInterfaces_kt__xgvzfp();
  return EMPTY_SERIALIZER_ARRAY;
}
var EMPTY_SERIALIZER_ARRAY;
var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
  if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
    properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_SERIALIZER_ARRAY = [];
  }
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new CharArraySerializer();
  return CharArraySerializer_instance;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new DoubleArraySerializer();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new FloatArraySerializer();
  return FloatArraySerializer_instance;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new LongArraySerializer();
  return LongArraySerializer_instance;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new ULongArraySerializer();
  return ULongArraySerializer_instance;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new IntArraySerializer();
  return IntArraySerializer_instance;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new UIntArraySerializer();
  return UIntArraySerializer_instance;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new ShortArraySerializer();
  return ShortArraySerializer_instance;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new UShortArraySerializer();
  return UShortArraySerializer_instance;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new ByteArraySerializer();
  return ByteArraySerializer_instance;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new UByteArraySerializer();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new BooleanArraySerializer();
  return BooleanArraySerializer_instance;
}
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().e3(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new StringSerializer();
  return StringSerializer_instance;
}
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance === VOID)
    new CharSerializer();
  return CharSerializer_instance;
}
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance === VOID)
    new DoubleSerializer();
  return DoubleSerializer_instance;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new FloatSerializer();
  return FloatSerializer_instance;
}
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance === VOID)
    new LongSerializer();
  return LongSerializer_instance;
}
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new IntSerializer();
  return IntSerializer_instance;
}
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance === VOID)
    new ShortSerializer();
  return ShortSerializer_instance;
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new ByteSerializer();
  return ByteSerializer_instance;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new BooleanSerializer();
  return BooleanSerializer_instance;
}
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance === VOID)
    new UnitSerializer();
  return UnitSerializer_instance;
}
function error_0($this) {
  throw IllegalStateException.h5('Primitive descriptor does not have elements');
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkName(serialName);
  return new PrimitiveSerialDescriptor(serialName, kind);
}
function checkName(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var keys = get_BUILTIN_SERIALIZERS().f3();
  var _iterator__ex2g4s = keys.b1();
  while (_iterator__ex2g4s.c1()) {
    var primitive = _iterator__ex2g4s.d1();
    var simpleName = capitalize(ensureNotNull(primitive.yf()));
    var qualifiedName = 'kotlin.' + simpleName;
    if (equals_0(serialName, qualifiedName, true) || equals_0(serialName, simpleName, true)) {
      throw IllegalArgumentException.l(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
function capitalize(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  // Inline function 'kotlin.text.replaceFirstChar' call
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(_this__u8e3s4) > 0) {
    // Inline function 'kotlinx.serialization.internal.capitalize.<anonymous>' call
    var it = charSequenceGet(_this__u8e3s4, 0);
    var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString_1(it);
    var tmp_0 = toString(tmp$ret$1);
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = tmp_0 + _this__u8e3s4.substring(1);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = mapOf([to(PrimitiveClasses_getInstance().zg(), serializer_1(StringCompanionObject_instance)), to(getKClass(Char), serializer_2(Companion_getInstance_0())), to(PrimitiveClasses_getInstance().ch(), CharArraySerializer_0()), to(PrimitiveClasses_getInstance().xg(), serializer_3(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().ih(), DoubleArraySerializer_0()), to(PrimitiveClasses_getInstance().wg(), serializer_4(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().hh(), FloatArraySerializer_0()), to(getKClass(Long), serializer_5(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().gh(), LongArraySerializer_0()), to(getKClass(ULong), serializer_6(Companion_getInstance_2())), to(getKClass(ULongArray), ULongArraySerializer_0()), to(PrimitiveClasses_getInstance().vg(), serializer_7(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().fh(), IntArraySerializer_0()), to(getKClass(UInt), serializer_8(Companion_getInstance_3())), to(getKClass(UIntArray), UIntArraySerializer_0()), to(PrimitiveClasses_getInstance().ug(), serializer_9(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().eh(), ShortArraySerializer_0()), to(getKClass(UShort), serializer_10(Companion_getInstance_4())), to(getKClass(UShortArray), UShortArraySerializer_0()), to(PrimitiveClasses_getInstance().tg(), serializer_11(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().dh(), ByteArraySerializer_0()), to(getKClass(UByte), serializer_12(Companion_getInstance_5())), to(getKClass(UByteArray), UByteArraySerializer_0()), to(PrimitiveClasses_getInstance().sg(), serializer_13(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().bh(), BooleanArraySerializer_0()), to(getKClass(Unit), serializer_14(Unit_instance)), to(PrimitiveClasses_getInstance().rg(), NothingSerializer_0()), to(getKClass(Duration), serializer_15(Companion_getInstance()))]);
  }
}
function tagBlock($this, tag, block) {
  $this.z1d(tag);
  var r = block();
  if (!$this.i1d_1) {
    $this.a1e();
  }
  $this.i1d_1 = false;
  return r;
}
function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    return this$0.vy($deserializer, $previousValue);
  };
}
function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var this_0 = this$0;
    var isNullabilitySupported = $deserializer.yu().ww();
    var tmp;
    if (isNullabilitySupported || this_0.iy()) {
      // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeNullableSerializableElement.<anonymous>.<anonymous>' call
      tmp = this$0.vy($deserializer, $previousValue);
    } else {
      tmp = this_0.jy();
    }
    return tmp;
  };
}
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.jv('key', $keySerializer.yu());
    $this$buildSerialDescriptor.jv('value', $valueSerializer.yu());
    return Unit_instance;
  };
}
function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.jv('first', $keySerializer.yu());
    $this$buildClassSerialDescriptor.jv('second', $valueSerializer.yu());
    return Unit_instance;
  };
}
function decodeSequentially_1($this, composite) {
  var a = composite.kz($this.w1e_1, 0, $this.t1e_1);
  var b = composite.kz($this.w1e_1, 1, $this.u1e_1);
  var c = composite.kz($this.w1e_1, 2, $this.v1e_1);
  composite.yy($this.w1e_1);
  return new Triple(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.oz($this.w1e_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.kz($this.w1e_1, 0, $this.t1e_1);
        break;
      case 1:
        b = composite.kz($this.w1e_1, 1, $this.u1e_1);
        break;
      case 2:
        c = composite.kz($this.w1e_1, 2, $this.v1e_1);
        break;
      default:
        throw SerializationException.aw('Unexpected index ' + index);
    }
  }
  composite.yy($this.w1e_1);
  if (a === get_NULL())
    throw SerializationException.aw("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException.aw("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException.aw("Element 'third' is missing");
  var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
  var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
  return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
}
function TripleSerializer$descriptor$lambda(this$0) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.jv('first', this$0.t1e_1.yu());
    $this$buildClassSerialDescriptor.jv('second', this$0.u1e_1.yu());
    $this$buildClassSerialDescriptor.jv('third', this$0.v1e_1.yu());
    return Unit_instance;
  };
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance === VOID)
    new ULongSerializer();
  return ULongSerializer_instance;
}
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance === VOID)
    new UIntSerializer();
  return UIntSerializer_instance;
}
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance === VOID)
    new UShortSerializer();
  return UShortSerializer_instance;
}
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance === VOID)
    new UByteSerializer();
  return UByteSerializer_instance;
}
function get_EmptySerializersModuleLegacyJs() {
  _init_properties_SerializersModule_kt__u78ha3();
  return EmptySerializersModule;
}
var EmptySerializersModule;
function plus(_this__u8e3s4, other) {
  _init_properties_SerializersModule_kt__u78ha3();
  // Inline function 'kotlinx.serialization.modules.SerializersModule' call
  var builder = new SerializersModuleBuilder();
  // Inline function 'kotlinx.serialization.modules.plus.<anonymous>' call
  builder.p1g(_this__u8e3s4);
  builder.p1g(other);
  return builder.n14();
}
var properties_initialized_SerializersModule_kt_fjigjn;
function _init_properties_SerializersModule_kt__u78ha3() {
  if (!properties_initialized_SerializersModule_kt_fjigjn) {
    properties_initialized_SerializersModule_kt_fjigjn = true;
    EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
  }
}
function EmptySerializersModule_0() {
  return get_EmptySerializersModuleLegacyJs();
}
function SerializersModuleCollector$contextual$lambda($serializer) {
  return function (it) {
    return $serializer;
  };
}
function createCache(factory) {
  return new createCache$1(factory);
}
function createParametrizedCache(factory) {
  return new createParametrizedCache$1(factory);
}
function isInterface_0(_this__u8e3s4) {
  return get_isInterface(_this__u8e3s4);
}
function get_isInterface(_this__u8e3s4) {
  if (_this__u8e3s4 === PrimitiveClasses_getInstance().rg())
    return false;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp1_safe_receiver = get_js(_this__u8e3s4).$metadata$;
  return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.kind) == 'interface';
}
function compiledSerializerImpl(_this__u8e3s4) {
  var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().rg()) {
      tmp_0 = NothingSerializer_getInstance();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
      tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
    }
    var tmp_1 = tmp_0;
    tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
  throw SerializationException.aw(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
}
function isReferenceArray(rootClass) {
  return rootClass.equals(PrimitiveClasses_getInstance().yg());
}
function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
  var tmp;
  try {
    // Inline function 'kotlin.reflect.findAssociatedObject' call
    var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
    var tmp_0;
    if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
      tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
    } else {
      if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
        var tmp_1 = assocObject.r17(args.slice());
        tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
      } else {
        tmp_0 = null;
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_2;
    var e = $p;
    tmp_2 = null;
    tmp = tmp_2;
  }
  return tmp;
}
function toNativeArrayImpl(_this__u8e3s4, eClass) {
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(_this__u8e3s4);
}
function getChecked(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException.ze('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function getChecked_0(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException.ze('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
//region block: post-declaration
initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer');
initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer');
initMetadataForClass(SerializationException, 'SerializationException', SerializationException.zv);
initMetadataForClass(UnknownFieldException, 'UnknownFieldException');
initMetadataForClass(MissingFieldException, 'MissingFieldException');
initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(elementDescriptors$1);
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(elementNames$1);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
initMetadataForInterface(CachedNames, 'CachedNames');
protoOf(SerialDescriptorImpl).ww = get_isNullable;
protoOf(SerialDescriptorImpl).hx = get_isInline;
initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(SerialKind, 'SerialKind');
initMetadataForObject(ENUM, 'ENUM');
initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL');
initMetadataForClass(PolymorphicKind, 'PolymorphicKind');
initMetadataForObject(SEALED, 'SEALED');
initMetadataForObject(OPEN, 'OPEN');
initMetadataForClass(PrimitiveKind, 'PrimitiveKind');
initMetadataForObject(BOOLEAN, 'BOOLEAN');
initMetadataForObject(BYTE, 'BYTE');
initMetadataForObject(CHAR, 'CHAR');
initMetadataForObject(SHORT, 'SHORT');
initMetadataForObject(INT, 'INT');
initMetadataForObject(LONG, 'LONG');
initMetadataForObject(FLOAT, 'FLOAT');
initMetadataForObject(DOUBLE, 'DOUBLE');
initMetadataForObject(STRING, 'STRING');
initMetadataForClass(StructureKind, 'StructureKind');
initMetadataForObject(CLASS, 'CLASS');
initMetadataForObject(LIST, 'LIST');
initMetadataForObject(MAP, 'MAP');
initMetadataForObject(OBJECT, 'OBJECT');
initMetadataForInterface(Decoder, 'Decoder');
initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
protoOf(AbstractDecoder).kz = decodeSerializableElement$default;
protoOf(AbstractDecoder).wy = decodeSerializableValue;
protoOf(AbstractDecoder).nz = decodeSequentially;
protoOf(AbstractDecoder).pz = decodeCollectionSize;
initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForInterface(Encoder, 'Encoder');
initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
protoOf(AbstractEncoder).t10 = encodeNotNullMark;
protoOf(AbstractEncoder).u10 = beginCollection;
protoOf(AbstractEncoder).q10 = encodeSerializableValue;
protoOf(AbstractEncoder).s10 = encodeNullableSerializableValue;
protoOf(AbstractEncoder).v10 = shouldEncodeElementDefault;
initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForObject(NothingSerializer, 'NothingSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
protoOf(ListLikeDescriptor).ww = get_isNullable;
protoOf(ListLikeDescriptor).hx = get_isInline;
protoOf(ListLikeDescriptor).jx = get_annotations;
initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc');
initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc');
initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc');
protoOf(MapLikeDescriptor).ww = get_isNullable;
protoOf(MapLikeDescriptor).hx = get_isInline;
protoOf(MapLikeDescriptor).jx = get_annotations;
initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc');
initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc');
initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc');
initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor');
initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer');
initMetadataForClass(CollectionSerializer, 'CollectionSerializer');
initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer');
initMetadataForClass(HashSetSerializer, 'HashSetSerializer');
initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer');
initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer');
initMetadataForClass(HashMapSerializer, 'HashMapSerializer');
initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer');
initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer');
initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer');
initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
initMetadataForCompanion(Companion);
initMetadataForClass(ElementMarker, 'ElementMarker');
initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
protoOf(PluginGeneratedSerialDescriptor).ww = get_isNullable;
protoOf(PluginGeneratedSerialDescriptor).hx = get_isInline;
initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(EnumDescriptor, 'EnumDescriptor');
initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor');
initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
protoOf(InlinePrimitiveDescriptor$1).e17 = typeParametersSerializers;
initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
initMetadataForObject(NoOpEncoder, 'NoOpEncoder');
protoOf(NothingSerialDescriptor).ww = get_isNullable;
protoOf(NothingSerialDescriptor).hx = get_isInline;
protoOf(NothingSerialDescriptor).jx = get_annotations;
initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForInterface(SerializerFactory, 'SerializerFactory');
initMetadataForObject(CharArraySerializer, 'CharArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(DoubleArraySerializer, 'DoubleArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(FloatArraySerializer, 'FloatArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(LongArraySerializer, 'LongArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ULongArraySerializer, 'ULongArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(IntArraySerializer, 'IntArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UIntArraySerializer, 'UIntArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ShortArraySerializer, 'ShortArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UShortArraySerializer, 'UShortArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ByteArraySerializer, 'ByteArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UByteArraySerializer, 'UByteArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(BooleanArraySerializer, 'BooleanArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder');
initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder');
initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder');
initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder');
initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder');
initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder');
initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder');
initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder');
initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder');
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder');
initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder');
initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder');
initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
protoOf(PrimitiveSerialDescriptor).ww = get_isNullable;
protoOf(PrimitiveSerialDescriptor).hx = get_isInline;
protoOf(PrimitiveSerialDescriptor).jx = get_annotations;
initMetadataForClass(PrimitiveSerialDescriptor, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
protoOf(TaggedDecoder).kz = decodeSerializableElement$default;
protoOf(TaggedDecoder).wy = decodeSerializableValue;
protoOf(TaggedDecoder).nz = decodeSequentially;
protoOf(TaggedDecoder).pz = decodeCollectionSize;
initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder');
initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(MapEntrySerializer, 'MapEntrySerializer');
initMetadataForClass(PairSerializer, 'PairSerializer');
initMetadataForClass(TripleSerializer, 'TripleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PolymorphicModuleBuilder, 'PolymorphicModuleBuilder');
initMetadataForClass(SerializersModule, 'SerializersModule');
initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl');
initMetadataForClass(ContextualProvider, 'ContextualProvider');
initMetadataForClass(Argless, 'Argless');
initMetadataForClass(WithTypeArguments, 'WithTypeArguments');
initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
initMetadataForClass(SerializersModuleBuilder, 'SerializersModuleBuilder', VOID, VOID, [SerializersModuleCollector]);
initMetadataForClass(SerializerAlreadyRegisteredException, 'SerializerAlreadyRegisteredException');
initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
initMetadataForClass(createCache$1);
initMetadataForClass(createParametrizedCache$1);
//endregion
//region block: exports
export {
  OPEN_getInstance as OPEN_getInstance1g2m5lmphyw5,
  SEALED_getInstance as SEALED_getInstance2brzxtciy6zxg,
  DOUBLE_getInstance as DOUBLE_getInstance15940a49743iy,
  INT_getInstance as INT_getInstancety325w3vt74z,
  STRING_getInstance as STRING_getInstance2md3nu8ka1da4,
  CONTEXTUAL_getInstance as CONTEXTUAL_getInstance3iftz58z4hzud,
  ENUM_getInstance as ENUM_getInstance3qjro8veu1n4s,
  CLASS_getInstance as CLASS_getInstanceycyg9nehd7tt,
  LIST_getInstance as LIST_getInstance31r89469rgwkw,
  MAP_getInstance as MAP_getInstance242ky2ofgg8p5,
  OBJECT_getInstance as OBJECT_getInstanceoefnxtom5aro,
  BooleanSerializer_getInstance as BooleanSerializer_getInstance1a8uvzxl1s4k4,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance2y096mioqlqlr,
  FloatSerializer_getInstance as FloatSerializer_getInstance3n1kixy3l1peh,
  IntArraySerializer_getInstance as IntArraySerializer_getInstance1wseiuhv9iku9,
  IntSerializer_getInstance as IntSerializer_getInstance3jjhuzya8j8kz,
  StringSerializer_getInstance as StringSerializer_getInstance100dxy5jlaaom,
  UIntSerializer_getInstance as UIntSerializer_getInstance1f4j3hi6ln6i8,
  ListSerializer as ListSerializer1hxuk9dx5n9du,
  MapSerializer as MapSerializer11kmegt3g5c1g,
  get_nullable as get_nullable197rfua9r7fsz,
  serializer_1 as serializer1x79l67jvwntn,
  serializer_10 as serializer1q7c5q67ysppr,
  serializer_8 as serializer3ikrxnm8b29d6,
  serializer_12 as serializer36584sjyg5661,
  serializer_6 as serializer2lw83vwvpnyms,
  PolymorphicKind as PolymorphicKindla9gurooefwb,
  BOOLEAN as BOOLEANwrdyi6z6g9t5,
  BYTE as BYTE3998jn8in9237,
  CHAR as CHARm37y40it075g,
  DOUBLE as DOUBLExcx7tue0m1mu,
  FLOAT as FLOAT2bpqq59z4fuiu,
  INT as INT3fyso8r94fmo5,
  LONG as LONG2pk1o9ze1il7c,
  SHORT as SHORTo7q5gsuxaxs,
  STRING as STRINGrrr0wq2m1c2f,
  PrimitiveKind as PrimitiveKindndgbuh6is7ze,
  PrimitiveSerialDescriptor_0 as PrimitiveSerialDescriptor3egfp53lutxj2,
  get_annotations as get_annotationshjxdbdcl8kmv,
  get_isInline as get_isInline5x26qrhi9qs6,
  get_isNullable as get_isNullable36pbikm8xb7bz,
  SerialDescriptor as SerialDescriptor2pelqekb5ic3a,
  CONTEXTUAL as CONTEXTUAL2e1gz2tojnpmj,
  ENUM as ENUMlmq49cvwy4ow,
  CLASS as CLASS3e32wwn6b97hz,
  LIST as LIST2gzos3vzn3slg,
  MAP as MAPtg3mcyan4256,
  OBJECT as OBJECT2nknkrqb4pf7m,
  buildClassSerialDescriptor as buildClassSerialDescriptors2a6xdp6mrtw,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
  get_elementNames as get_elementNamesl5b6t976dltd,
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
  CompositeDecoder as CompositeDecoder2tzm7wpwkr0og,
  CompositeEncoder as CompositeEncoderknecpkexzn3v,
  Decoder as Decoder23nde051s631g,
  Encoder as Encoderqvmrpqtq8hnu,
  AbstractPolymorphicSerializer as AbstractPolymorphicSerializer1ccxwp48nfy58,
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  ElementMarker as ElementMarker33ojvsajwmzts,
  typeParametersSerializers as typeParametersSerializers2likxjr48tr7y,
  GeneratedSerializer as GeneratedSerializer1f7t7hssdd2ws,
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
  ObjectSerializer as ObjectSerializer2kjkucmygguwd,
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  SerializerFactory as SerializerFactory1qv9hivitncuv,
  createAnnotatedEnumSerializer as createAnnotatedEnumSerializer20ay4pme9p2h9,
  createSimpleEnumSerializer as createSimpleEnumSerializer2guioz11kk1m0,
  jsonCachedSerialNames as jsonCachedSerialNameslxufy2gu43jt,
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
  EmptySerializersModule_0 as EmptySerializersModule991ju6pz9b79,
  PolymorphicModuleBuilder as PolymorphicModuleBuilder1c33fhfru2id5,
  SerializersModuleBuilder as SerializersModuleBuilderfxsfdohcdipc,
  contextual as contextual3hpp1gupsu4al,
  SerializersModuleCollector as SerializersModuleCollector3dddz14wd7brg,
  plus as plus1c7xncg0dvi6w,
  DeserializationStrategy as DeserializationStrategy1z3z5pj9f7zc8,
  KSerializer as KSerializerzf77vz1967fq,
  MissingFieldException as MissingFieldException24tqif29emcmi,
  PolymorphicSerializer as PolymorphicSerializer3p3fzpdobi8hh,
  SealedClassSerializer as SealedClassSerializeriwipiibk55zc,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  SerializationStrategy as SerializationStrategyh6ouydnm6hci,
  UnknownFieldException as UnknownFieldExceptiona60e3a6v1xqo,
  findPolymorphicSerializer_0 as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer as findPolymorphicSerializerk638ixyjovk5,
  serializer_0 as serializer1hwzc6m64v1op,
  serializer as serializer1i4e9ym37oxmo,
};
//endregion
